/* eslint-disable */
import { getLocale, experimentalStaticLocale } from "../runtime.js"

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Abandonsession1Inputs */
/** @typedef {{}} Abandonsessioncancel2Inputs */
/** @typedef {{}} Abandonsessionconfirm2Inputs */
/** @typedef {{}} Abandonsessionconfirmaction3Inputs */
/** @typedef {{}} Accountaccessdenied2Inputs */
/** @typedef {{}} Agentbusy1Inputs */
/** @typedef {{ count: NonNullable<unknown> }} Agenthostbusymany3Inputs */
/** @typedef {{}} Agenthostbusyone3Inputs */
/** @typedef {{}} Agentmodel1Inputs */
/** @typedef {{}} Agentmodelhint2Inputs */
/** @typedef {{}} Agentname1Inputs */
/** @typedef {{}} Agentstatus1Inputs */
/** @typedef {{}} Agentthinking1Inputs */
/** @typedef {{}} Agentworking1Inputs */
/** @typedef {{}} Apicallfailed2Inputs */
/** @typedef {{}} Apiunreachable1Inputs */
/** @typedef {{}} Appssectionlabel2Inputs */
/** @typedef {{}} Attachfiles1Inputs */
/** @typedef {{}} Automationscanceledit2Inputs */
/** @typedef {{}} Automationscreate1Inputs */
/** @typedef {{}} Automationscreateheading2Inputs */
/** @typedef {{}} Automationsdelete1Inputs */
/** @typedef {{}} Automationsdisable1Inputs */
/** @typedef {{}} Automationsdisabled1Inputs */
/** @typedef {{}} Automationsedit1Inputs */
/** @typedef {{}} Automationsempty1Inputs */
/** @typedef {{}} Automationsenable1Inputs */
/** @typedef {{}} Automationsenabled1Inputs */
/** @typedef {{}} Automationsfieldcron2Inputs */
/** @typedef {{}} Automationsfieldparentsession3Inputs */
/** @typedef {{}} Automationsfieldprompt2Inputs */
/** @typedef {{}} Automationsfieldproposemr3Inputs */
/** @typedef {{}} Automationsfieldtitle2Inputs */
/** @typedef {{}} Automationsgroupsheading2Inputs */
/** @typedef {{ status: NonNullable<unknown>, summary: NonNullable<unknown> }} Automationslatestrun2Inputs */
/** @typedef {{}} Automationslead1Inputs */
/** @typedef {{}} Automationsnav1Inputs */
/** @typedef {{}} Automationsnoparentsessions3Inputs */
/** @typedef {{}} Automationsopensession2Inputs */
/** @typedef {{}} Automationsreadonly2Inputs */
/** @typedef {{}} Automationsrunnow2Inputs */
/** @typedef {{}} Automationssave1Inputs */
/** @typedef {{}} Automationstitle1Inputs */
/** @typedef {{}} Brandlogoalt2Inputs */
/** @typedef {{}} Browserlivepreview2Inputs */
/** @typedef {{}} Browserlivepreviewalt3Inputs */
/** @typedef {{}} Browserlivepreviewhide3Inputs */
/** @typedef {{}} Browserlivepreviewshow3Inputs */
/** @typedef {{}} Capturepreview1Inputs */
/** @typedef {{}} Capturepreviewfailed2Inputs */
/** @typedef {{}} Capturepreviewhint2Inputs */
/** @typedef {{}} Capturepreviewunavailable2Inputs */
/** @typedef {{}} Captureselectionhint2Inputs */
/** @typedef {{}} Captureselectionunavailable2Inputs */
/** @typedef {{}} Changetarget1Inputs */
/** @typedef {{}} Chatregion1Inputs */
/** @typedef {{}} Chattitle1Inputs */
/** @typedef {{}} Closeconversationhistory2Inputs */
/** @typedef {{}} Collapsechat1Inputs */
/** @typedef {{}} Collapseconversationrail2Inputs */
/** @typedef {{}} Continuelastappaction3Inputs */
/** @typedef {{}} Continuelastappbadge3Inputs */
/** @typedef {{}} Continuelastappdescription3Inputs */
/** @typedef {{}} Continuelastappsectionlabel4Inputs */
/** @typedef {{}} Conversationhistory1Inputs */
/** @typedef {{}} Conversationhistoryempty2Inputs */
/** @typedef {{}} Conversationrail1Inputs */
/** @typedef {{}} Conversationrailmineempty3Inputs */
/** @typedef {{}} Conversationrailshowall3Inputs */
/** @typedef {{}} Conversationrailshowmine3Inputs */
/** @typedef {{}} Copylink1Inputs */
/** @typedef {{}} Defaultindependentappaction3Inputs */
/** @typedef {{}} Defaultindependentappbadge3Inputs */
/** @typedef {{}} Deletescratchappaction3Inputs */
/** @typedef {{}} Deletescratchappcancel3Inputs */
/** @typedef {{}} Deletescratchappconfirmaction4Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Deletescratchappconfirmlead4Inputs */
/** @typedef {{}} Deletescratchappconfirmtitle4Inputs */
/** @typedef {{}} Deletescratchappworking3Inputs */
/** @typedef {{}} Deploycancelaction2Inputs */
/** @typedef {{}} Deployconfirmaction2Inputs */
/** @typedef {{}} Deploymodedialogtitle3Inputs */
/** @typedef {{}} Deploymodenewapp3Inputs */
/** @typedef {{}} Deploymodereplaceparent3Inputs */
/** @typedef {{}} Deploymodethisapp3Inputs */
/** @typedef {{}} Deploynewsluglabel3Inputs */
/** @typedef {{}} Deploynewslugplaceholder3Inputs */
/** @typedef {{ url: NonNullable<unknown> }} Deploypublicurlhint3Inputs */
/** @typedef {{}} Deploysessionaction2Inputs */
/** @typedef {{ hostname: NonNullable<unknown> }} Deploysessionsucceeded2Inputs */
/** @typedef {{}} Deploysessionworking2Inputs */
/** @typedef {{}} Deploysluginvalidhint3Inputs */
/** @typedef {{}} Deployslugreservedhint3Inputs */
/** @typedef {{}} Deployslugtakenhint3Inputs */
/** @typedef {{}} Deployedappeditaction3Inputs */
/** @typedef {{}} Deployedappopenaction3Inputs */
/** @typedef {{}} Deployedapprevertaction3Inputs */
/** @typedef {{}} Deployedapprevertcancel3Inputs */
/** @typedef {{}} Deployedapprevertconfirm3Inputs */
/** @typedef {{}} Deployedapprevertdialogtitle4Inputs */
/** @typedef {{}} Deployedapprevertempty3Inputs */
/** @typedef {{}} Deployedapprevertworking3Inputs */
/** @typedef {{}} Deployedappstopaction3Inputs */
/** @typedef {{}} Deployedappsempty2Inputs */
/** @typedef {{}} Deployedappssectionlabel3Inputs */
/** @typedef {{}} Dictatemessage1Inputs */
/** @typedef {{}} Dictationunsupported1Inputs */
/** @typedef {{ fileName: NonNullable<unknown> }} Downloadattachment1Inputs */
/** @typedef {{}} Expandchat1Inputs */
/** @typedef {{}} Expandconversationrail2Inputs */
/** @typedef {{}} Favoritebadge1Inputs */
/** @typedef {{}} Favoriteopenaction2Inputs */
/** @typedef {{}} Favoritesempty1Inputs */
/** @typedef {{}} Favoritessectionlabel2Inputs */
/** @typedef {{}} Homelead1Inputs */
/** @typedef {{}} Identityproviderunavailable2Inputs */
/** @typedef {{}} Independentappssectionempty3Inputs */
/** @typedef {{}} Independentappssectionlabel3Inputs */
/** @typedef {{}} Inspecthint1Inputs */
/** @typedef {{ messageKey: NonNullable<unknown>, filePart: NonNullable<unknown>, textPart: NonNullable<unknown> }} Inspectselectionwithkey3Inputs */
/** @typedef {{}} Inspectselectionsheader2Inputs */
/** @typedef {{}} Linkcopied1Inputs */
/** @typedef {{}} Lintfailed1Inputs */
/** @typedef {{}} Loadingsession1Inputs */
/** @typedef {{}} LoginInputs */
/** @typedef {{}} Logininstructions1Inputs */
/** @typedef {{}} Logintitle1Inputs */
/** @typedef {{}} LogoutInputs */
/** @typedef {{}} Maximizechat1Inputs */
/** @typedef {{}} Mergerequestopened2Inputs */
/** @typedef {{}} Mergerequestupdated2Inputs */
/** @typedef {{}} Messageplaceholder1Inputs */
/** @typedef {{}} Missingrootelement2Inputs */
/** @typedef {{}} Newconversation1Inputs */
/** @typedef {{}} Newscratchappaction3Inputs */
/** @typedef {{}} Newscratchappcancel3Inputs */
/** @typedef {{}} Newscratchappcreating3Inputs */
/** @typedef {{}} Newscratchappdescription3Inputs */
/** @typedef {{}} Newscratchapplabel3Inputs */
/** @typedef {{}} Newscratchappnamelabel4Inputs */
/** @typedef {{}} Newscratchappnameplaceholder4Inputs */
/** @typedef {{ slug: NonNullable<unknown> }} Newscratchappslughint4Inputs */
/** @typedef {{}} Newscratchappsluginvalid4Inputs */
/** @typedef {{}} Openmergerequest2Inputs */
/** @typedef {{}} Openspecarchivemergerequestopened4Inputs */
/** @typedef {{}} Pagetitle1Inputs */
/** @typedef {{}} Pinfavorite1Inputs */
/** @typedef {{}} Previewdevicedesktop2Inputs */
/** @typedef {{}} Previewdevicemobile2Inputs */
/** @typedef {{}} Previewdeviceswitch2Inputs */
/** @typedef {{}} Previewdevicetablet2Inputs */
/** @typedef {{}} Previewoff1Inputs */
/** @typedef {{}} Previewpathapply2Inputs */
/** @typedef {{}} Previewpathback2Inputs */
/** @typedef {{}} Previewpathforward2Inputs */
/** @typedef {{}} Previewpathinvalid2Inputs */
/** @typedef {{}} Previewpathlabel2Inputs */
/** @typedef {{}} Previewpathofforigin3Inputs */
/** @typedef {{}} Previewpathpresetcatalogue3Inputs */
/** @typedef {{}} Previewpathpresetdiaporama3Inputs */
/** @typedef {{}} Previewpathpresethome3Inputs */
/** @typedef {{}} Previewpathpresets2Inputs */
/** @typedef {{}} Previewregion1Inputs */
/** @typedef {{}} Previewrestoring1Inputs */
/** @typedef {{}} Promptactivityclose2Inputs */
/** @typedef {{}} Promptactivityempty2Inputs */
/** @typedef {{}} Promptactivitylead2Inputs */
/** @typedef {{}} Promptactivityloadfailed3Inputs */
/** @typedef {{}} Promptactivitytitle2Inputs */
/** @typedef {{}} Promptactivityuntitled2Inputs */
/** @typedef {{}} Quickstartaction2Inputs */
/** @typedef {{}} Quickstartlabel2Inputs */
/** @typedef {{}} Quickstartnostartertarget4Inputs */
/** @typedef {{}} Quickstartplaceholder2Inputs */
/** @typedef {{}} Quickstartworking2Inputs */
/** @typedef {{}} Redeploysessionaction2Inputs */
/** @typedef {{ fileName: NonNullable<unknown> }} Removeattachment1Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Removeselection1Inputs */
/** @typedef {{}} Renameconversation1Inputs */
/** @typedef {{}} Requestrequired1Inputs */
/** @typedef {{}} Resizechat1Inputs */
/** @typedef {{}} Restorechat1Inputs */
/** @typedef {{}} Saveconversationtitle2Inputs */
/** @typedef {{}} Securespace1Inputs */
/** @typedef {{}} Selectcomponent1Inputs */
/** @typedef {{}} Sendmessage1Inputs */
/** @typedef {{}} Servicetemporarilyunavailable2Inputs */
/** @typedef {{}} Sessionaccessdenied2Inputs */
/** @typedef {{}} Sessionaccessdeniedlead3Inputs */
/** @typedef {{}} Sessionloading1Inputs */
/** @typedef {{}} Sessionmakeopen2Inputs */
/** @typedef {{}} Sessionmakeprivate2Inputs */
/** @typedef {{}} Sessionmissing1Inputs */
/** @typedef {{}} Sessionpublishmenu2Inputs */
/** @typedef {{}} Sessionshareadd2Inputs */
/** @typedef {{}} Sessionshareemailplaceholder3Inputs */
/** @typedef {{}} Sessionsharedwithyou3Inputs */
/** @typedef {{}} Sessionsharing1Inputs */
/** @typedef {{}} Sessionunshare1Inputs */
/** @typedef {{ email: NonNullable<unknown> }} Sessionunshareemail2Inputs */
/** @typedef {{}} Sessionvisibilityopen2Inputs */
/** @typedef {{}} Sessionvisibilityprivate2Inputs */
/** @typedef {{}} SettingsInputs */
/** @typedef {{}} Settingsclose1Inputs */
/** @typedef {{}} Settingscreateappheading3Inputs */
/** @typedef {{}} Settingscreateapplead3Inputs */
/** @typedef {{}} Settingscreateappsubtitle3Inputs */
/** @typedef {{}} Settingscreateapptoggle3Inputs */
/** @typedef {{}} Settingsdeleteappheading3Inputs */
/** @typedef {{}} Settingsdeleteapplead3Inputs */
/** @typedef {{}} Settingsdeleteappsubtitle3Inputs */
/** @typedef {{}} Settingsdeleteapptoggle3Inputs */
/** @typedef {{}} Settingseyebrow1Inputs */
/** @typedef {{}} Settingspreviewpathbarheading4Inputs */
/** @typedef {{}} Settingspreviewpathbarlead4Inputs */
/** @typedef {{}} Settingspreviewpathbarsubtitle4Inputs */
/** @typedef {{}} Settingspreviewpathbartoggle4Inputs */
/** @typedef {{}} Settingspromptactivityheading3Inputs */
/** @typedef {{}} Settingspromptactivitylead3Inputs */
/** @typedef {{}} Settingspromptactivitysubtitle3Inputs */
/** @typedef {{}} Settingspromptactivitytoggle3Inputs */
/** @typedef {{}} Settingstitle1Inputs */
/** @typedef {{}} Sourceconnectaction2Inputs */
/** @typedef {{}} Sourceconnectconnecting2Inputs */
/** @typedef {{}} Sourceconnectopenviewer3Inputs */
/** @typedef {{}} Sourceconnectskip2Inputs */
/** @typedef {{}} Sourceconnecttitle2Inputs */
/** @typedef {{}} Startpreview1Inputs */
/** @typedef {{}} Startsectionlabel2Inputs */
/** @typedef {{}} Startsectionlead2Inputs */
/** @typedef {{}} Startsectiontitle2Inputs */
/** @typedef {{}} Startingrequest1Inputs */
/** @typedef {{}} Stopdictation1Inputs */
/** @typedef {{}} Stopselectingcomponent2Inputs */
/** @typedef {{}} Stopturn1Inputs */
/** @typedef {{}} Studioname1Inputs */
/** @typedef {{}} Studiowelcomeeyebrow2Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleattack3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleembellish3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitlehello3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleidea3Inputs */
/** @typedef {{ name: NonNullable<unknown> }} Studiowelcometitleimprove3Inputs */
/** @typedef {{}} Syncsessionbase2Inputs */
/** @typedef {{}} Targetopenaction2Inputs */
/** @typedef {{}} Targetpickerempty2Inputs */
/** @typedef {{}} Targetpickerlead2Inputs */
/** @typedef {{ label: NonNullable<unknown> }} Targetpreviewlabel2Inputs */
/** @typedef {{}} Targetpreviewunavailable2Inputs */
/** @typedef {{}} Targetresumeaction2Inputs */
/** @typedef {{}} Targetselectlabel2Inputs */
/** @typedef {{}} Targettilemenulabel3Inputs */
/** @typedef {{}} Targetwipbadge2Inputs */
/** @typedef {{}} Teachbrowserdiscard2Inputs */
/** @typedef {{}} Teachbrowseropenviewer3Inputs */
/** @typedef {{}} Teachbrowserpromote2Inputs */
/** @typedef {{}} Teachbrowserready2Inputs */
/** @typedef {{}} Teachbrowserrecording2Inputs */
/** @typedef {{}} Teachbrowsershowpath3Inputs */
/** @typedef {{}} Teachbrowserstop2Inputs */
/** @typedef {{}} Teachbrowsersummary2Inputs */
/** @typedef {{}} Technicaldetails1Inputs */
/** @typedef {{}} Unknowncreator1Inputs */
/** @typedef {{}} Unpinfavorite1Inputs */
/** @typedef {{}} Untitledconversation1Inputs */
/** @typedef {{}} Updatemergerequest2Inputs */
/** @typedef {{}} Websitesectionempty2Inputs */
/** @typedef {{}} Websitesectionlabel2Inputs */
/** @typedef {{}} Youname1Inputs */
import * as __fr from "./fr.js"
import * as __en from "./en.js"
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Abandonsession1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const abandonsession1 = /** @type {((inputs?: Abandonsession1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Abandonsession1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.abandonsession1(inputs)
	return __fr.abandonsession1(inputs)
});
export { abandonsession1 as "abandonSession" }
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Abandonsessioncancel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const abandonsessioncancel2 = /** @type {((inputs?: Abandonsessioncancel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Abandonsessioncancel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.abandonsessioncancel2(inputs)
	return __fr.abandonsessioncancel2(inputs)
});
export { abandonsessioncancel2 as "abandonSessionCancel" }
/**
* | output |
* | --- |
* | "Delete this conversation? The preview, Git branch, and all related history will be permanently removed." |
*
* @param {Abandonsessionconfirm2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const abandonsessionconfirm2 = /** @type {((inputs?: Abandonsessionconfirm2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Abandonsessionconfirm2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.abandonsessionconfirm2(inputs)
	return __fr.abandonsessionconfirm2(inputs)
});
export { abandonsessionconfirm2 as "abandonSessionConfirm" }
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Abandonsessionconfirmaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const abandonsessionconfirmaction3 = /** @type {((inputs?: Abandonsessionconfirmaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Abandonsessionconfirmaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.abandonsessionconfirmaction3(inputs)
	return __fr.abandonsessionconfirmaction3(inputs)
});
export { abandonsessionconfirmaction3 as "abandonSessionConfirmAction" }
/**
* | output |
* | --- |
* | "Your account has no access to Studio." |
*
* @param {Accountaccessdenied2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const accountaccessdenied2 = /** @type {((inputs?: Accountaccessdenied2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountaccessdenied2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.accountaccessdenied2(inputs)
	return __fr.accountaccessdenied2(inputs)
});
export { accountaccessdenied2 as "accountAccessDenied" }
/**
* | output |
* | --- |
* | "A turn is already in progress on this conversation." |
*
* @param {Agentbusy1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agentbusy1 = /** @type {((inputs?: Agentbusy1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agentbusy1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agentbusy1(inputs)
	return __fr.agentbusy1(inputs)
});
export { agentbusy1 as "agentBusy" }
/**
* | output |
* | --- |
* | "The agent is busy on {count} other conversations. Your request may wait." |
*
* @param {Agenthostbusymany3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agenthostbusymany3 = /** @type {((inputs: Agenthostbusymany3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenthostbusymany3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agenthostbusymany3(inputs)
	return __fr.agenthostbusymany3(inputs)
});
export { agenthostbusymany3 as "agentHostBusyMany" }
/**
* | output |
* | --- |
* | "The agent is busy on 1 other conversation. Your request may wait." |
*
* @param {Agenthostbusyone3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agenthostbusyone3 = /** @type {((inputs?: Agenthostbusyone3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenthostbusyone3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agenthostbusyone3(inputs)
	return __fr.agenthostbusyone3(inputs)
});
export { agenthostbusyone3 as "agentHostBusyOne" }
/**
* | output |
* | --- |
* | "Model" |
*
* @param {Agentmodel1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agentmodel1 = /** @type {((inputs?: Agentmodel1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agentmodel1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agentmodel1(inputs)
	return __fr.agentmodel1(inputs)
});
export { agentmodel1 as "agentModel" }
/**
* | output |
* | --- |
* | "Model used for the next messages" |
*
* @param {Agentmodelhint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agentmodelhint2 = /** @type {((inputs?: Agentmodelhint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agentmodelhint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agentmodelhint2(inputs)
	return __fr.agentmodelhint2(inputs)
});
export { agentmodelhint2 as "agentModelHint" }
/**
* | output |
* | --- |
* | "Assistant" |
*
* @param {Agentname1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agentname1 = /** @type {((inputs?: Agentname1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agentname1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agentname1(inputs)
	return __fr.agentname1(inputs)
});
export { agentname1 as "agentName" }
/**
* | output |
* | --- |
* | "Step" |
*
* @param {Agentstatus1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agentstatus1 = /** @type {((inputs?: Agentstatus1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agentstatus1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agentstatus1(inputs)
	return __fr.agentstatus1(inputs)
});
export { agentstatus1 as "agentStatus" }
/**
* | output |
* | --- |
* | "Thinking" |
*
* @param {Agentthinking1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agentthinking1 = /** @type {((inputs?: Agentthinking1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agentthinking1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agentthinking1(inputs)
	return __fr.agentthinking1(inputs)
});
export { agentthinking1 as "agentThinking" }
/**
* | output |
* | --- |
* | "Working…" |
*
* @param {Agentworking1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const agentworking1 = /** @type {((inputs?: Agentworking1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agentworking1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agentworking1(inputs)
	return __fr.agentworking1(inputs)
});
export { agentworking1 as "agentWorking" }
/**
* | output |
* | --- |
* | "Something went wrong. Try again in a moment." |
*
* @param {Apicallfailed2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const apicallfailed2 = /** @type {((inputs?: Apicallfailed2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apicallfailed2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.apicallfailed2(inputs)
	return __fr.apicallfailed2(inputs)
});
export { apicallfailed2 as "apiCallFailed" }
/**
* | output |
* | --- |
* | "Studio is temporarily unavailable. Try again in a moment." |
*
* @param {Apiunreachable1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const apiunreachable1 = /** @type {((inputs?: Apiunreachable1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apiunreachable1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.apiunreachable1(inputs)
	return __fr.apiunreachable1(inputs)
});
export { apiunreachable1 as "apiUnreachable" }
/**
* | output |
* | --- |
* | "Apps" |
*
* @param {Appssectionlabel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const appssectionlabel2 = /** @type {((inputs?: Appssectionlabel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Appssectionlabel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.appssectionlabel2(inputs)
	return __fr.appssectionlabel2(inputs)
});
export { appssectionlabel2 as "appsSectionLabel" }
/**
* | output |
* | --- |
* | "Attach a file" |
*
* @param {Attachfiles1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const attachfiles1 = /** @type {((inputs?: Attachfiles1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attachfiles1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.attachfiles1(inputs)
	return __fr.attachfiles1(inputs)
});
export { attachfiles1 as "attachFiles" }
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Automationscanceledit2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationscanceledit2 = /** @type {((inputs?: Automationscanceledit2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationscanceledit2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationscanceledit2(inputs)
	return __fr.automationscanceledit2(inputs)
});
export { automationscanceledit2 as "automationsCancelEdit" }
/**
* | output |
* | --- |
* | "Create" |
*
* @param {Automationscreate1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationscreate1 = /** @type {((inputs?: Automationscreate1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationscreate1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationscreate1(inputs)
	return __fr.automationscreate1(inputs)
});
export { automationscreate1 as "automationsCreate" }
/**
* | output |
* | --- |
* | "New automation" |
*
* @param {Automationscreateheading2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationscreateheading2 = /** @type {((inputs?: Automationscreateheading2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationscreateheading2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationscreateheading2(inputs)
	return __fr.automationscreateheading2(inputs)
});
export { automationscreateheading2 as "automationsCreateHeading" }
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Automationsdelete1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsdelete1 = /** @type {((inputs?: Automationsdelete1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsdelete1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsdelete1(inputs)
	return __fr.automationsdelete1(inputs)
});
export { automationsdelete1 as "automationsDelete" }
/**
* | output |
* | --- |
* | "Disable" |
*
* @param {Automationsdisable1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsdisable1 = /** @type {((inputs?: Automationsdisable1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsdisable1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsdisable1(inputs)
	return __fr.automationsdisable1(inputs)
});
export { automationsdisable1 as "automationsDisable" }
/**
* | output |
* | --- |
* | "disabled" |
*
* @param {Automationsdisabled1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsdisabled1 = /** @type {((inputs?: Automationsdisabled1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsdisabled1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsdisabled1(inputs)
	return __fr.automationsdisabled1(inputs)
});
export { automationsdisabled1 as "automationsDisabled" }
/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Automationsedit1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsedit1 = /** @type {((inputs?: Automationsedit1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsedit1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsedit1(inputs)
	return __fr.automationsedit1(inputs)
});
export { automationsedit1 as "automationsEdit" }
/**
* | output |
* | --- |
* | "No automations yet." |
*
* @param {Automationsempty1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsempty1 = /** @type {((inputs?: Automationsempty1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsempty1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsempty1(inputs)
	return __fr.automationsempty1(inputs)
});
export { automationsempty1 as "automationsEmpty" }
/**
* | output |
* | --- |
* | "Enable" |
*
* @param {Automationsenable1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsenable1 = /** @type {((inputs?: Automationsenable1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsenable1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsenable1(inputs)
	return __fr.automationsenable1(inputs)
});
export { automationsenable1 as "automationsEnable" }
/**
* | output |
* | --- |
* | "enabled" |
*
* @param {Automationsenabled1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsenabled1 = /** @type {((inputs?: Automationsenabled1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsenabled1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsenabled1(inputs)
	return __fr.automationsenabled1(inputs)
});
export { automationsenabled1 as "automationsEnabled" }
/**
* | output |
* | --- |
* | "Schedule (cron)" |
*
* @param {Automationsfieldcron2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsfieldcron2 = /** @type {((inputs?: Automationsfieldcron2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsfieldcron2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsfieldcron2(inputs)
	return __fr.automationsfieldcron2(inputs)
});
export { automationsfieldcron2 as "automationsFieldCron" }
/**
* | output |
* | --- |
* | "Parent conversation" |
*
* @param {Automationsfieldparentsession3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsfieldparentsession3 = /** @type {((inputs?: Automationsfieldparentsession3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsfieldparentsession3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsfieldparentsession3(inputs)
	return __fr.automationsfieldparentsession3(inputs)
});
export { automationsfieldparentsession3 as "automationsFieldParentSession" }
/**
* | output |
* | --- |
* | "Instructions" |
*
* @param {Automationsfieldprompt2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsfieldprompt2 = /** @type {((inputs?: Automationsfieldprompt2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsfieldprompt2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsfieldprompt2(inputs)
	return __fr.automationsfieldprompt2(inputs)
});
export { automationsfieldprompt2 as "automationsFieldPrompt" }
/**
* | output |
* | --- |
* | "Propose a merge request after the run" |
*
* @param {Automationsfieldproposemr3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsfieldproposemr3 = /** @type {((inputs?: Automationsfieldproposemr3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsfieldproposemr3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsfieldproposemr3(inputs)
	return __fr.automationsfieldproposemr3(inputs)
});
export { automationsfieldproposemr3 as "automationsFieldProposeMr" }
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Automationsfieldtitle2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsfieldtitle2 = /** @type {((inputs?: Automationsfieldtitle2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsfieldtitle2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsfieldtitle2(inputs)
	return __fr.automationsfieldtitle2(inputs)
});
export { automationsfieldtitle2 as "automationsFieldTitle" }
/**
* | output |
* | --- |
* | "By conversation" |
*
* @param {Automationsgroupsheading2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsgroupsheading2 = /** @type {((inputs?: Automationsgroupsheading2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsgroupsheading2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsgroupsheading2(inputs)
	return __fr.automationsgroupsheading2(inputs)
});
export { automationsgroupsheading2 as "automationsGroupsHeading" }
/**
* | output |
* | --- |
* | "Latest run ({status}): {summary}" |
*
* @param {Automationslatestrun2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationslatestrun2 = /** @type {((inputs: Automationslatestrun2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationslatestrun2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationslatestrun2(inputs)
	return __fr.automationslatestrun2(inputs)
});
export { automationslatestrun2 as "automationsLatestRun" }
/**
* | output |
* | --- |
* | "Scheduled recipes linked to a Studio conversation. Each run inherits the parent session's target." |
*
* @param {Automationslead1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationslead1 = /** @type {((inputs?: Automationslead1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationslead1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationslead1(inputs)
	return __fr.automationslead1(inputs)
});
export { automationslead1 as "automationsLead" }
/**
* | output |
* | --- |
* | "Automations" |
*
* @param {Automationsnav1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsnav1 = /** @type {((inputs?: Automationsnav1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsnav1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsnav1(inputs)
	return __fr.automationsnav1(inputs)
});
export { automationsnav1 as "automationsNav" }
/**
* | output |
* | --- |
* | "No conversation available" |
*
* @param {Automationsnoparentsessions3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsnoparentsessions3 = /** @type {((inputs?: Automationsnoparentsessions3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsnoparentsessions3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsnoparentsessions3(inputs)
	return __fr.automationsnoparentsessions3(inputs)
});
export { automationsnoparentsessions3 as "automationsNoParentSessions" }
/**
* | output |
* | --- |
* | "Open conversation" |
*
* @param {Automationsopensession2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsopensession2 = /** @type {((inputs?: Automationsopensession2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsopensession2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsopensession2(inputs)
	return __fr.automationsopensession2(inputs)
});
export { automationsopensession2 as "automationsOpenSession" }
/**
* | output |
* | --- |
* | "Read-only — you cannot manage automations." |
*
* @param {Automationsreadonly2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsreadonly2 = /** @type {((inputs?: Automationsreadonly2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsreadonly2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsreadonly2(inputs)
	return __fr.automationsreadonly2(inputs)
});
export { automationsreadonly2 as "automationsReadOnly" }
/**
* | output |
* | --- |
* | "Run now" |
*
* @param {Automationsrunnow2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationsrunnow2 = /** @type {((inputs?: Automationsrunnow2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationsrunnow2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationsrunnow2(inputs)
	return __fr.automationsrunnow2(inputs)
});
export { automationsrunnow2 as "automationsRunNow" }
/**
* | output |
* | --- |
* | "Save" |
*
* @param {Automationssave1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationssave1 = /** @type {((inputs?: Automationssave1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationssave1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationssave1(inputs)
	return __fr.automationssave1(inputs)
});
export { automationssave1 as "automationsSave" }
/**
* | output |
* | --- |
* | "Automations" |
*
* @param {Automationstitle1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const automationstitle1 = /** @type {((inputs?: Automationstitle1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automationstitle1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.automationstitle1(inputs)
	return __fr.automationstitle1(inputs)
});
export { automationstitle1 as "automationsTitle" }
/**
* | output |
* | --- |
* | "Stimcar" |
*
* @param {Brandlogoalt2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const brandlogoalt2 = /** @type {((inputs?: Brandlogoalt2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brandlogoalt2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.brandlogoalt2(inputs)
	return __fr.brandlogoalt2(inputs)
});
export { brandlogoalt2 as "brandLogoAlt" }
/**
* | output |
* | --- |
* | "Browser" |
*
* @param {Browserlivepreview2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const browserlivepreview2 = /** @type {((inputs?: Browserlivepreview2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browserlivepreview2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.browserlivepreview2(inputs)
	return __fr.browserlivepreview2(inputs)
});
export { browserlivepreview2 as "browserLivePreview" }
/**
* | output |
* | --- |
* | "Live preview of the agent-driven browser" |
*
* @param {Browserlivepreviewalt3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const browserlivepreviewalt3 = /** @type {((inputs?: Browserlivepreviewalt3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browserlivepreviewalt3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.browserlivepreviewalt3(inputs)
	return __fr.browserlivepreviewalt3(inputs)
});
export { browserlivepreviewalt3 as "browserLivePreviewAlt" }
/**
* | output |
* | --- |
* | "Hide" |
*
* @param {Browserlivepreviewhide3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const browserlivepreviewhide3 = /** @type {((inputs?: Browserlivepreviewhide3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browserlivepreviewhide3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.browserlivepreviewhide3(inputs)
	return __fr.browserlivepreviewhide3(inputs)
});
export { browserlivepreviewhide3 as "browserLivePreviewHide" }
/**
* | output |
* | --- |
* | "Show browser" |
*
* @param {Browserlivepreviewshow3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const browserlivepreviewshow3 = /** @type {((inputs?: Browserlivepreviewshow3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Browserlivepreviewshow3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.browserlivepreviewshow3(inputs)
	return __fr.browserlivepreviewshow3(inputs)
});
export { browserlivepreviewshow3 as "browserLivePreviewShow" }
/**
* | output |
* | --- |
* | "Capture preview" |
*
* @param {Capturepreview1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const capturepreview1 = /** @type {((inputs?: Capturepreview1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capturepreview1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.capturepreview1(inputs)
	return __fr.capturepreview1(inputs)
});
export { capturepreview1 as "capturePreview" }
/**
* | output |
* | --- |
* | "Could not capture the preview." |
*
* @param {Capturepreviewfailed2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const capturepreviewfailed2 = /** @type {((inputs?: Capturepreviewfailed2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capturepreviewfailed2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.capturepreviewfailed2(inputs)
	return __fr.capturepreviewfailed2(inputs)
});
export { capturepreviewfailed2 as "capturePreviewFailed" }
/**
* | output |
* | --- |
* | "Captures the whole preview (no screen share)." |
*
* @param {Capturepreviewhint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const capturepreviewhint2 = /** @type {((inputs?: Capturepreviewhint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capturepreviewhint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.capturepreviewhint2(inputs)
	return __fr.capturepreviewhint2(inputs)
});
export { capturepreviewhint2 as "capturePreviewHint" }
/**
* | output |
* | --- |
* | "Preview capture is not available right now." |
*
* @param {Capturepreviewunavailable2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const capturepreviewunavailable2 = /** @type {((inputs?: Capturepreviewunavailable2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capturepreviewunavailable2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.capturepreviewunavailable2(inputs)
	return __fr.capturepreviewunavailable2(inputs)
});
export { capturepreviewunavailable2 as "capturePreviewUnavailable" }
/**
* | output |
* | --- |
* | "Captures the element selected with the crosshair (no screen share)." |
*
* @param {Captureselectionhint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const captureselectionhint2 = /** @type {((inputs?: Captureselectionhint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Captureselectionhint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.captureselectionhint2(inputs)
	return __fr.captureselectionhint2(inputs)
});
export { captureselectionhint2 as "captureSelectionHint" }
/**
* | output |
* | --- |
* | "Reselect the element with the crosshair, then try capture again." |
*
* @param {Captureselectionunavailable2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const captureselectionunavailable2 = /** @type {((inputs?: Captureselectionunavailable2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Captureselectionunavailable2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.captureselectionunavailable2(inputs)
	return __fr.captureselectionunavailable2(inputs)
});
export { captureselectionunavailable2 as "captureSelectionUnavailable" }
/**
* | output |
* | --- |
* | "Switch application" |
*
* @param {Changetarget1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const changetarget1 = /** @type {((inputs?: Changetarget1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changetarget1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.changetarget1(inputs)
	return __fr.changetarget1(inputs)
});
export { changetarget1 as "changeTarget" }
/**
* | output |
* | --- |
* | "Conversation" |
*
* @param {Chatregion1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const chatregion1 = /** @type {((inputs?: Chatregion1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatregion1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.chatregion1(inputs)
	return __fr.chatregion1(inputs)
});
export { chatregion1 as "chatRegion" }
/**
* | output |
* | --- |
* | "Conversation" |
*
* @param {Chattitle1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const chattitle1 = /** @type {((inputs?: Chattitle1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chattitle1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.chattitle1(inputs)
	return __fr.chattitle1(inputs)
});
export { chattitle1 as "chatTitle" }
/**
* | output |
* | --- |
* | "Close history" |
*
* @param {Closeconversationhistory2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const closeconversationhistory2 = /** @type {((inputs?: Closeconversationhistory2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closeconversationhistory2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.closeconversationhistory2(inputs)
	return __fr.closeconversationhistory2(inputs)
});
export { closeconversationhistory2 as "closeConversationHistory" }
/**
* | output |
* | --- |
* | "Fold conversation aside" |
*
* @param {Collapsechat1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const collapsechat1 = /** @type {((inputs?: Collapsechat1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collapsechat1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.collapsechat1(inputs)
	return __fr.collapsechat1(inputs)
});
export { collapsechat1 as "collapseChat" }
/**
* | output |
* | --- |
* | "Collapse conversation list" |
*
* @param {Collapseconversationrail2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const collapseconversationrail2 = /** @type {((inputs?: Collapseconversationrail2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collapseconversationrail2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.collapseconversationrail2(inputs)
	return __fr.collapseconversationrail2(inputs)
});
export { collapseconversationrail2 as "collapseConversationRail" }
/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Continuelastappaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const continuelastappaction3 = /** @type {((inputs?: Continuelastappaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Continuelastappaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.continuelastappaction3(inputs)
	return __fr.continuelastappaction3(inputs)
});
export { continuelastappaction3 as "continueLastAppAction" }
/**
* | output |
* | --- |
* | "Last app" |
*
* @param {Continuelastappbadge3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const continuelastappbadge3 = /** @type {((inputs?: Continuelastappbadge3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Continuelastappbadge3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.continuelastappbadge3(inputs)
	return __fr.continuelastappbadge3(inputs)
});
export { continuelastappbadge3 as "continueLastAppBadge" }
/**
* | output |
* | --- |
* | "Resume your last independent application." |
*
* @param {Continuelastappdescription3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const continuelastappdescription3 = /** @type {((inputs?: Continuelastappdescription3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Continuelastappdescription3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.continuelastappdescription3(inputs)
	return __fr.continuelastappdescription3(inputs)
});
export { continuelastappdescription3 as "continueLastAppDescription" }
/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Continuelastappsectionlabel4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const continuelastappsectionlabel4 = /** @type {((inputs?: Continuelastappsectionlabel4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Continuelastappsectionlabel4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.continuelastappsectionlabel4(inputs)
	return __fr.continuelastappsectionlabel4(inputs)
});
export { continuelastappsectionlabel4 as "continueLastAppSectionLabel" }
/**
* | output |
* | --- |
* | "Conversation history" |
*
* @param {Conversationhistory1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const conversationhistory1 = /** @type {((inputs?: Conversationhistory1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversationhistory1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.conversationhistory1(inputs)
	return __fr.conversationhistory1(inputs)
});
export { conversationhistory1 as "conversationHistory" }
/**
* | output |
* | --- |
* | "No conversations yet." |
*
* @param {Conversationhistoryempty2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const conversationhistoryempty2 = /** @type {((inputs?: Conversationhistoryempty2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversationhistoryempty2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.conversationhistoryempty2(inputs)
	return __fr.conversationhistoryempty2(inputs)
});
export { conversationhistoryempty2 as "conversationHistoryEmpty" }
/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Conversationrail1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const conversationrail1 = /** @type {((inputs?: Conversationrail1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversationrail1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.conversationrail1(inputs)
	return __fr.conversationrail1(inputs)
});
export { conversationrail1 as "conversationRail" }
/**
* | output |
* | --- |
* | "You have no conversations yet." |
*
* @param {Conversationrailmineempty3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const conversationrailmineempty3 = /** @type {((inputs?: Conversationrailmineempty3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversationrailmineempty3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.conversationrailmineempty3(inputs)
	return __fr.conversationrailmineempty3(inputs)
});
export { conversationrailmineempty3 as "conversationRailMineEmpty" }
/**
* | output |
* | --- |
* | "Show all conversations" |
*
* @param {Conversationrailshowall3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const conversationrailshowall3 = /** @type {((inputs?: Conversationrailshowall3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversationrailshowall3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.conversationrailshowall3(inputs)
	return __fr.conversationrailshowall3(inputs)
});
export { conversationrailshowall3 as "conversationRailShowAll" }
/**
* | output |
* | --- |
* | "Show only mine" |
*
* @param {Conversationrailshowmine3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const conversationrailshowmine3 = /** @type {((inputs?: Conversationrailshowmine3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversationrailshowmine3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.conversationrailshowmine3(inputs)
	return __fr.conversationrailshowmine3(inputs)
});
export { conversationrailshowmine3 as "conversationRailShowMine" }
/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Copylink1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const copylink1 = /** @type {((inputs?: Copylink1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copylink1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.copylink1(inputs)
	return __fr.copylink1(inputs)
});
export { copylink1 as "copyLink" }
/**
* | output |
* | --- |
* | "Start here" |
*
* @param {Defaultindependentappaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const defaultindependentappaction3 = /** @type {((inputs?: Defaultindependentappaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Defaultindependentappaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.defaultindependentappaction3(inputs)
	return __fr.defaultindependentappaction3(inputs)
});
export { defaultindependentappaction3 as "defaultIndependentAppAction" }
/**
* | output |
* | --- |
* | "Start here" |
*
* @param {Defaultindependentappbadge3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const defaultindependentappbadge3 = /** @type {((inputs?: Defaultindependentappbadge3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Defaultindependentappbadge3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.defaultindependentappbadge3(inputs)
	return __fr.defaultindependentappbadge3(inputs)
});
export { defaultindependentappbadge3 as "defaultIndependentAppBadge" }
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Deletescratchappaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deletescratchappaction3 = /** @type {((inputs?: Deletescratchappaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletescratchappaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deletescratchappaction3(inputs)
	return __fr.deletescratchappaction3(inputs)
});
export { deletescratchappaction3 as "deleteScratchAppAction" }
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Deletescratchappcancel3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deletescratchappcancel3 = /** @type {((inputs?: Deletescratchappcancel3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletescratchappcancel3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deletescratchappcancel3(inputs)
	return __fr.deletescratchappcancel3(inputs)
});
export { deletescratchappcancel3 as "deleteScratchAppCancel" }
/**
* | output |
* | --- |
* | "Delete app" |
*
* @param {Deletescratchappconfirmaction4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deletescratchappconfirmaction4 = /** @type {((inputs?: Deletescratchappconfirmaction4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletescratchappconfirmaction4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deletescratchappconfirmaction4(inputs)
	return __fr.deletescratchappconfirmaction4(inputs)
});
export { deletescratchappconfirmaction4 as "deleteScratchAppConfirmAction" }
/**
* | output |
* | --- |
* | "“{label}” and its conversations will be removed from the atelier. Deployed apps and GitLab projects are not deleted here." |
*
* @param {Deletescratchappconfirmlead4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deletescratchappconfirmlead4 = /** @type {((inputs: Deletescratchappconfirmlead4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletescratchappconfirmlead4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deletescratchappconfirmlead4(inputs)
	return __fr.deletescratchappconfirmlead4(inputs)
});
export { deletescratchappconfirmlead4 as "deleteScratchAppConfirmLead" }
/**
* | output |
* | --- |
* | "Delete this independent app?" |
*
* @param {Deletescratchappconfirmtitle4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deletescratchappconfirmtitle4 = /** @type {((inputs?: Deletescratchappconfirmtitle4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletescratchappconfirmtitle4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deletescratchappconfirmtitle4(inputs)
	return __fr.deletescratchappconfirmtitle4(inputs)
});
export { deletescratchappconfirmtitle4 as "deleteScratchAppConfirmTitle" }
/**
* | output |
* | --- |
* | "Deleting…" |
*
* @param {Deletescratchappworking3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deletescratchappworking3 = /** @type {((inputs?: Deletescratchappworking3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deletescratchappworking3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deletescratchappworking3(inputs)
	return __fr.deletescratchappworking3(inputs)
});
export { deletescratchappworking3 as "deleteScratchAppWorking" }
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Deploycancelaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploycancelaction2 = /** @type {((inputs?: Deploycancelaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploycancelaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploycancelaction2(inputs)
	return __fr.deploycancelaction2(inputs)
});
export { deploycancelaction2 as "deployCancelAction" }
/**
* | output |
* | --- |
* | "Confirm deploy" |
*
* @param {Deployconfirmaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployconfirmaction2 = /** @type {((inputs?: Deployconfirmaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployconfirmaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployconfirmaction2(inputs)
	return __fr.deployconfirmaction2(inputs)
});
export { deployconfirmaction2 as "deployConfirmAction" }
/**
* | output |
* | --- |
* | "How do you want to deploy?" |
*
* @param {Deploymodedialogtitle3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploymodedialogtitle3 = /** @type {((inputs?: Deploymodedialogtitle3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploymodedialogtitle3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploymodedialogtitle3(inputs)
	return __fr.deploymodedialogtitle3(inputs)
});
export { deploymodedialogtitle3 as "deployModeDialogTitle" }
/**
* | output |
* | --- |
* | "Deploy under a new identifier" |
*
* @param {Deploymodenewapp3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploymodenewapp3 = /** @type {((inputs?: Deploymodenewapp3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploymodenewapp3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploymodenewapp3(inputs)
	return __fr.deploymodenewapp3(inputs)
});
export { deploymodenewapp3 as "deployModeNewApp" }
/**
* | output |
* | --- |
* | "Update the already deployed app" |
*
* @param {Deploymodereplaceparent3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploymodereplaceparent3 = /** @type {((inputs?: Deploymodereplaceparent3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploymodereplaceparent3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploymodereplaceparent3(inputs)
	return __fr.deploymodereplaceparent3(inputs)
});
export { deploymodereplaceparent3 as "deployModeReplaceParent" }
/**
* | output |
* | --- |
* | "Deploy this application" |
*
* @param {Deploymodethisapp3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploymodethisapp3 = /** @type {((inputs?: Deploymodethisapp3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploymodethisapp3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploymodethisapp3(inputs)
	return __fr.deploymodethisapp3(inputs)
});
export { deploymodethisapp3 as "deployModeThisApp" }
/**
* | output |
* | --- |
* | "App name (URL)" |
*
* @param {Deploynewsluglabel3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploynewsluglabel3 = /** @type {((inputs?: Deploynewsluglabel3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploynewsluglabel3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploynewsluglabel3(inputs)
	return __fr.deploynewsluglabel3(inputs)
});
export { deploynewsluglabel3 as "deployNewSlugLabel" }
/**
* | output |
* | --- |
* | "my-new-app" |
*
* @param {Deploynewslugplaceholder3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploynewslugplaceholder3 = /** @type {((inputs?: Deploynewslugplaceholder3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploynewslugplaceholder3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploynewslugplaceholder3(inputs)
	return __fr.deploynewslugplaceholder3(inputs)
});
export { deploynewslugplaceholder3 as "deployNewSlugPlaceholder" }
/**
* | output |
* | --- |
* | "Public URL: {url}" |
*
* @param {Deploypublicurlhint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploypublicurlhint3 = /** @type {((inputs: Deploypublicurlhint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploypublicurlhint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploypublicurlhint3(inputs)
	return __fr.deploypublicurlhint3(inputs)
});
export { deploypublicurlhint3 as "deployPublicUrlHint" }
/**
* | output |
* | --- |
* | "Deploy" |
*
* @param {Deploysessionaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploysessionaction2 = /** @type {((inputs?: Deploysessionaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploysessionaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploysessionaction2(inputs)
	return __fr.deploysessionaction2(inputs)
});
export { deploysessionaction2 as "deploySessionAction" }
/**
* | output |
* | --- |
* | "Application deployed: {hostname}" |
*
* @param {Deploysessionsucceeded2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploysessionsucceeded2 = /** @type {((inputs: Deploysessionsucceeded2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploysessionsucceeded2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploysessionsucceeded2(inputs)
	return __fr.deploysessionsucceeded2(inputs)
});
export { deploysessionsucceeded2 as "deploySessionSucceeded" }
/**
* | output |
* | --- |
* | "Deploying…" |
*
* @param {Deploysessionworking2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploysessionworking2 = /** @type {((inputs?: Deploysessionworking2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploysessionworking2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploysessionworking2(inputs)
	return __fr.deploysessionworking2(inputs)
});
export { deploysessionworking2 as "deploySessionWorking" }
/**
* | output |
* | --- |
* | "Invalid identifier (lowercase letters, digits, hyphens)." |
*
* @param {Deploysluginvalidhint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deploysluginvalidhint3 = /** @type {((inputs?: Deploysluginvalidhint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deploysluginvalidhint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deploysluginvalidhint3(inputs)
	return __fr.deploysluginvalidhint3(inputs)
});
export { deploysluginvalidhint3 as "deploySlugInvalidHint" }
/**
* | output |
* | --- |
* | "Reserved identifier (mktp, web, scratch, studio, p…)." |
*
* @param {Deployslugreservedhint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployslugreservedhint3 = /** @type {((inputs?: Deployslugreservedhint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployslugreservedhint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployslugreservedhint3(inputs)
	return __fr.deployslugreservedhint3(inputs)
});
export { deployslugreservedhint3 as "deploySlugReservedHint" }
/**
* | output |
* | --- |
* | "This identifier is already used by a deployed app." |
*
* @param {Deployslugtakenhint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployslugtakenhint3 = /** @type {((inputs?: Deployslugtakenhint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployslugtakenhint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployslugtakenhint3(inputs)
	return __fr.deployslugtakenhint3(inputs)
});
export { deployslugtakenhint3 as "deploySlugTakenHint" }
/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Deployedappeditaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedappeditaction3 = /** @type {((inputs?: Deployedappeditaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedappeditaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedappeditaction3(inputs)
	return __fr.deployedappeditaction3(inputs)
});
export { deployedappeditaction3 as "deployedAppEditAction" }
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Deployedappopenaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedappopenaction3 = /** @type {((inputs?: Deployedappopenaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedappopenaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedappopenaction3(inputs)
	return __fr.deployedappopenaction3(inputs)
});
export { deployedappopenaction3 as "deployedAppOpenAction" }
/**
* | output |
* | --- |
* | "Revert to…" |
*
* @param {Deployedapprevertaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedapprevertaction3 = /** @type {((inputs?: Deployedapprevertaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedapprevertaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedapprevertaction3(inputs)
	return __fr.deployedapprevertaction3(inputs)
});
export { deployedapprevertaction3 as "deployedAppRevertAction" }
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Deployedapprevertcancel3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedapprevertcancel3 = /** @type {((inputs?: Deployedapprevertcancel3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedapprevertcancel3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedapprevertcancel3(inputs)
	return __fr.deployedapprevertcancel3(inputs)
});
export { deployedapprevertcancel3 as "deployedAppRevertCancel" }
/**
* | output |
* | --- |
* | "Restore this version" |
*
* @param {Deployedapprevertconfirm3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedapprevertconfirm3 = /** @type {((inputs?: Deployedapprevertconfirm3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedapprevertconfirm3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedapprevertconfirm3(inputs)
	return __fr.deployedapprevertconfirm3(inputs)
});
export { deployedapprevertconfirm3 as "deployedAppRevertConfirm" }
/**
* | output |
* | --- |
* | "Revert a deployed version" |
*
* @param {Deployedapprevertdialogtitle4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedapprevertdialogtitle4 = /** @type {((inputs?: Deployedapprevertdialogtitle4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedapprevertdialogtitle4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedapprevertdialogtitle4(inputs)
	return __fr.deployedapprevertdialogtitle4(inputs)
});
export { deployedapprevertdialogtitle4 as "deployedAppRevertDialogTitle" }
/**
* | output |
* | --- |
* | "No deployment history available." |
*
* @param {Deployedapprevertempty3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedapprevertempty3 = /** @type {((inputs?: Deployedapprevertempty3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedapprevertempty3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedapprevertempty3(inputs)
	return __fr.deployedapprevertempty3(inputs)
});
export { deployedapprevertempty3 as "deployedAppRevertEmpty" }
/**
* | output |
* | --- |
* | "Restoring…" |
*
* @param {Deployedapprevertworking3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedapprevertworking3 = /** @type {((inputs?: Deployedapprevertworking3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedapprevertworking3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedapprevertworking3(inputs)
	return __fr.deployedapprevertworking3(inputs)
});
export { deployedapprevertworking3 as "deployedAppRevertWorking" }
/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Deployedappstopaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedappstopaction3 = /** @type {((inputs?: Deployedappstopaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedappstopaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedappstopaction3(inputs)
	return __fr.deployedappstopaction3(inputs)
});
export { deployedappstopaction3 as "deployedAppStopAction" }
/**
* | output |
* | --- |
* | "No deployed applications yet." |
*
* @param {Deployedappsempty2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedappsempty2 = /** @type {((inputs?: Deployedappsempty2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedappsempty2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedappsempty2(inputs)
	return __fr.deployedappsempty2(inputs)
});
export { deployedappsempty2 as "deployedAppsEmpty" }
/**
* | output |
* | --- |
* | "Deployed apps" |
*
* @param {Deployedappssectionlabel3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const deployedappssectionlabel3 = /** @type {((inputs?: Deployedappssectionlabel3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deployedappssectionlabel3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.deployedappssectionlabel3(inputs)
	return __fr.deployedappssectionlabel3(inputs)
});
export { deployedappssectionlabel3 as "deployedAppsSectionLabel" }
/**
* | output |
* | --- |
* | "Dictate message" |
*
* @param {Dictatemessage1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const dictatemessage1 = /** @type {((inputs?: Dictatemessage1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictatemessage1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.dictatemessage1(inputs)
	return __fr.dictatemessage1(inputs)
});
export { dictatemessage1 as "dictateMessage" }
/**
* | output |
* | --- |
* | "Dictation is not available in this browser." |
*
* @param {Dictationunsupported1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const dictationunsupported1 = /** @type {((inputs?: Dictationunsupported1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictationunsupported1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.dictationunsupported1(inputs)
	return __fr.dictationunsupported1(inputs)
});
export { dictationunsupported1 as "dictationUnsupported" }
/**
* | output |
* | --- |
* | "Download {fileName}" |
*
* @param {Downloadattachment1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const downloadattachment1 = /** @type {((inputs: Downloadattachment1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadattachment1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.downloadattachment1(inputs)
	return __fr.downloadattachment1(inputs)
});
export { downloadattachment1 as "downloadAttachment" }
/**
* | output |
* | --- |
* | "Open conversation" |
*
* @param {Expandchat1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const expandchat1 = /** @type {((inputs?: Expandchat1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expandchat1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.expandchat1(inputs)
	return __fr.expandchat1(inputs)
});
export { expandchat1 as "expandChat" }
/**
* | output |
* | --- |
* | "Show conversation list" |
*
* @param {Expandconversationrail2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const expandconversationrail2 = /** @type {((inputs?: Expandconversationrail2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expandconversationrail2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.expandconversationrail2(inputs)
	return __fr.expandconversationrail2(inputs)
});
export { expandconversationrail2 as "expandConversationRail" }
/**
* | output |
* | --- |
* | "Favorite" |
*
* @param {Favoritebadge1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const favoritebadge1 = /** @type {((inputs?: Favoritebadge1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Favoritebadge1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.favoritebadge1(inputs)
	return __fr.favoritebadge1(inputs)
});
export { favoritebadge1 as "favoriteBadge" }
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Favoriteopenaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const favoriteopenaction2 = /** @type {((inputs?: Favoriteopenaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Favoriteopenaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.favoriteopenaction2(inputs)
	return __fr.favoriteopenaction2(inputs)
});
export { favoriteopenaction2 as "favoriteOpenAction" }
/**
* | output |
* | --- |
* | "No favorite conversations yet." |
*
* @param {Favoritesempty1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const favoritesempty1 = /** @type {((inputs?: Favoritesempty1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Favoritesempty1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.favoritesempty1(inputs)
	return __fr.favoritesempty1(inputs)
});
export { favoritesempty1 as "favoritesEmpty" }
/**
* | output |
* | --- |
* | "Favorites" |
*
* @param {Favoritessectionlabel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const favoritessectionlabel2 = /** @type {((inputs?: Favoritessectionlabel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Favoritessectionlabel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.favoritessectionlabel2(inputs)
	return __fr.favoritessectionlabel2(inputs)
});
export { favoritessectionlabel2 as "favoritesSectionLabel" }
/**
* | output |
* | --- |
* | "Describe what you want to change. Each send opens a dedicated conversation, visible to the whole studio team." |
*
* @param {Homelead1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const homelead1 = /** @type {((inputs?: Homelead1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homelead1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.homelead1(inputs)
	return __fr.homelead1(inputs)
});
export { homelead1 as "homeLead" }
/**
* | output |
* | --- |
* | "The sign-in service is temporarily unavailable. Please try again later." |
*
* @param {Identityproviderunavailable2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const identityproviderunavailable2 = /** @type {((inputs?: Identityproviderunavailable2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Identityproviderunavailable2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.identityproviderunavailable2(inputs)
	return __fr.identityproviderunavailable2(inputs)
});
export { identityproviderunavailable2 as "identityProviderUnavailable" }
/**
* | output |
* | --- |
* | "No independent applications yet." |
*
* @param {Independentappssectionempty3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const independentappssectionempty3 = /** @type {((inputs?: Independentappssectionempty3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Independentappssectionempty3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.independentappssectionempty3(inputs)
	return __fr.independentappssectionempty3(inputs)
});
export { independentappssectionempty3 as "independentAppsSectionEmpty" }
/**
* | output |
* | --- |
* | "Independent apps" |
*
* @param {Independentappssectionlabel3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const independentappssectionlabel3 = /** @type {((inputs?: Independentappssectionlabel3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Independentappssectionlabel3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.independentappssectionlabel3(inputs)
	return __fr.independentappssectionlabel3(inputs)
});
export { independentappssectionlabel3 as "independentAppsSectionLabel" }
/**
* | output |
* | --- |
* | "Click an element in the preview." |
*
* @param {Inspecthint1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const inspecthint1 = /** @type {((inputs?: Inspecthint1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inspecthint1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inspecthint1(inputs)
	return __fr.inspecthint1(inputs)
});
export { inspecthint1 as "inspectHint" }
/**
* | output |
* | --- |
* | "- Selected UI: messageKey={messageKey}{filePart}{textPart}" |
*
* @param {Inspectselectionwithkey3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const inspectselectionwithkey3 = /** @type {((inputs: Inspectselectionwithkey3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inspectselectionwithkey3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inspectselectionwithkey3(inputs)
	return __fr.inspectselectionwithkey3(inputs)
});
export { inspectselectionwithkey3 as "inspectSelectionWithKey" }
/**
* | output |
* | --- |
* | "Selected UI components:" |
*
* @param {Inspectselectionsheader2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const inspectselectionsheader2 = /** @type {((inputs?: Inspectselectionsheader2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inspectselectionsheader2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inspectselectionsheader2(inputs)
	return __fr.inspectselectionsheader2(inputs)
});
export { inspectselectionsheader2 as "inspectSelectionsHeader" }
/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Linkcopied1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const linkcopied1 = /** @type {((inputs?: Linkcopied1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linkcopied1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.linkcopied1(inputs)
	return __fr.linkcopied1(inputs)
});
export { linkcopied1 as "linkCopied" }
/**
* | output |
* | --- |
* | "Could not send the proposal: automatic checks failed. Ask the assistant to fix them, then try again." |
*
* @param {Lintfailed1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const lintfailed1 = /** @type {((inputs?: Lintfailed1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lintfailed1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.lintfailed1(inputs)
	return __fr.lintfailed1(inputs)
});
export { lintfailed1 as "lintFailed" }
/**
* | output |
* | --- |
* | "Opening your workspace…" |
*
* @param {Loadingsession1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const loadingsession1 = /** @type {((inputs?: Loadingsession1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loadingsession1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.loadingsession1(inputs)
	return __fr.loadingsession1(inputs)
});
export { loadingsession1 as "loadingSession" }
/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {LoginInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const login = /** @type {((inputs?: LoginInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LoginInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.login(inputs)
	return __fr.login(inputs)
});
/**
* | output |
* | --- |
* | "Sign in with your Stimcar account to access Studio." |
*
* @param {Logininstructions1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const logininstructions1 = /** @type {((inputs?: Logininstructions1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logininstructions1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.logininstructions1(inputs)
	return __fr.logininstructions1(inputs)
});
export { logininstructions1 as "loginInstructions" }
/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Logintitle1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const logintitle1 = /** @type {((inputs?: Logintitle1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logintitle1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.logintitle1(inputs)
	return __fr.logintitle1(inputs)
});
export { logintitle1 as "loginTitle" }
/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {LogoutInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const logout = /** @type {((inputs?: LogoutInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LogoutInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.logout(inputs)
	return __fr.logout(inputs)
});
/**
* | output |
* | --- |
* | "Expand conversation" |
*
* @param {Maximizechat1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const maximizechat1 = /** @type {((inputs?: Maximizechat1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximizechat1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.maximizechat1(inputs)
	return __fr.maximizechat1(inputs)
});
export { maximizechat1 as "maximizeChat" }
/**
* | output |
* | --- |
* | "Proposal sent for review" |
*
* @param {Mergerequestopened2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const mergerequestopened2 = /** @type {((inputs?: Mergerequestopened2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mergerequestopened2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mergerequestopened2(inputs)
	return __fr.mergerequestopened2(inputs)
});
export { mergerequestopened2 as "mergeRequestOpened" }
/**
* | output |
* | --- |
* | "Proposal updated" |
*
* @param {Mergerequestupdated2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const mergerequestupdated2 = /** @type {((inputs?: Mergerequestupdated2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mergerequestupdated2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.mergerequestupdated2(inputs)
	return __fr.mergerequestupdated2(inputs)
});
export { mergerequestupdated2 as "mergeRequestUpdated" }
/**
* | output |
* | --- |
* | "Describe what you want…" |
*
* @param {Messageplaceholder1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const messageplaceholder1 = /** @type {((inputs?: Messageplaceholder1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messageplaceholder1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.messageplaceholder1(inputs)
	return __fr.messageplaceholder1(inputs)
});
export { messageplaceholder1 as "messagePlaceholder" }
/**
* | output |
* | --- |
* | "Element not found" |
*
* @param {Missingrootelement2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const missingrootelement2 = /** @type {((inputs?: Missingrootelement2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missingrootelement2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.missingrootelement2(inputs)
	return __fr.missingrootelement2(inputs)
});
export { missingrootelement2 as "missingRootElement" }
/**
* | output |
* | --- |
* | "New conversation" |
*
* @param {Newconversation1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newconversation1 = /** @type {((inputs?: Newconversation1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newconversation1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newconversation1(inputs)
	return __fr.newconversation1(inputs)
});
export { newconversation1 as "newConversation" }
/**
* | output |
* | --- |
* | "Create" |
*
* @param {Newscratchappaction3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchappaction3 = /** @type {((inputs?: Newscratchappaction3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchappaction3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchappaction3(inputs)
	return __fr.newscratchappaction3(inputs)
});
export { newscratchappaction3 as "newScratchAppAction" }
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Newscratchappcancel3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchappcancel3 = /** @type {((inputs?: Newscratchappcancel3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchappcancel3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchappcancel3(inputs)
	return __fr.newscratchappcancel3(inputs)
});
export { newscratchappcancel3 as "newScratchAppCancel" }
/**
* | output |
* | --- |
* | "Creating the application…" |
*
* @param {Newscratchappcreating3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchappcreating3 = /** @type {((inputs?: Newscratchappcreating3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchappcreating3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchappcreating3(inputs)
	return __fr.newscratchappcreating3(inputs)
});
export { newscratchappcreating3 as "newScratchAppCreating" }
/**
* | output |
* | --- |
* | "Create a shared application, then work on it in a session." |
*
* @param {Newscratchappdescription3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchappdescription3 = /** @type {((inputs?: Newscratchappdescription3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchappdescription3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchappdescription3(inputs)
	return __fr.newscratchappdescription3(inputs)
});
export { newscratchappdescription3 as "newScratchAppDescription" }
/**
* | output |
* | --- |
* | "New app" |
*
* @param {Newscratchapplabel3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchapplabel3 = /** @type {((inputs?: Newscratchapplabel3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchapplabel3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchapplabel3(inputs)
	return __fr.newscratchapplabel3(inputs)
});
export { newscratchapplabel3 as "newScratchAppLabel" }
/**
* | output |
* | --- |
* | "Application name" |
*
* @param {Newscratchappnamelabel4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchappnamelabel4 = /** @type {((inputs?: Newscratchappnamelabel4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchappnamelabel4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchappnamelabel4(inputs)
	return __fr.newscratchappnamelabel4(inputs)
});
export { newscratchappnamelabel4 as "newScratchAppNameLabel" }
/**
* | output |
* | --- |
* | "Late kanbans" |
*
* @param {Newscratchappnameplaceholder4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchappnameplaceholder4 = /** @type {((inputs?: Newscratchappnameplaceholder4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchappnameplaceholder4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchappnameplaceholder4(inputs)
	return __fr.newscratchappnameplaceholder4(inputs)
});
export { newscratchappnameplaceholder4 as "newScratchAppNamePlaceholder" }
/**
* | output |
* | --- |
* | "Identifier: {slug}" |
*
* @param {Newscratchappslughint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchappslughint4 = /** @type {((inputs: Newscratchappslughint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchappslughint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchappslughint4(inputs)
	return __fr.newscratchappslughint4(inputs)
});
export { newscratchappslughint4 as "newScratchAppSlugHint" }
/**
* | output |
* | --- |
* | "Enter a name that yields a valid identifier (letters, numbers, hyphens)." |
*
* @param {Newscratchappsluginvalid4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const newscratchappsluginvalid4 = /** @type {((inputs?: Newscratchappsluginvalid4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newscratchappsluginvalid4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.newscratchappsluginvalid4(inputs)
	return __fr.newscratchappsluginvalid4(inputs)
});
export { newscratchappsluginvalid4 as "newScratchAppSlugInvalid" }
/**
* | output |
* | --- |
* | "Propose changes" |
*
* @param {Openmergerequest2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const openmergerequest2 = /** @type {((inputs?: Openmergerequest2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openmergerequest2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.openmergerequest2(inputs)
	return __fr.openmergerequest2(inputs)
});
export { openmergerequest2 as "openMergeRequest" }
/**
* | output |
* | --- |
* | "OpenSpec sync/archive proposal" |
*
* @param {Openspecarchivemergerequestopened4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const openspecarchivemergerequestopened4 = /** @type {((inputs?: Openspecarchivemergerequestopened4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openspecarchivemergerequestopened4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.openspecarchivemergerequestopened4(inputs)
	return __fr.openspecarchivemergerequestopened4(inputs)
});
export { openspecarchivemergerequestopened4 as "openspecArchiveMergeRequestOpened" }
/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Pagetitle1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const pagetitle1 = /** @type {((inputs?: Pagetitle1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pagetitle1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.pagetitle1(inputs)
	return __fr.pagetitle1(inputs)
});
export { pagetitle1 as "pageTitle" }
/**
* | output |
* | --- |
* | "Add to favorites" |
*
* @param {Pinfavorite1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const pinfavorite1 = /** @type {((inputs?: Pinfavorite1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pinfavorite1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.pinfavorite1(inputs)
	return __fr.pinfavorite1(inputs)
});
export { pinfavorite1 as "pinFavorite" }
/**
* | output |
* | --- |
* | "Desktop" |
*
* @param {Previewdevicedesktop2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewdevicedesktop2 = /** @type {((inputs?: Previewdevicedesktop2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewdevicedesktop2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewdevicedesktop2(inputs)
	return __fr.previewdevicedesktop2(inputs)
});
export { previewdevicedesktop2 as "previewDeviceDesktop" }
/**
* | output |
* | --- |
* | "Mobile" |
*
* @param {Previewdevicemobile2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewdevicemobile2 = /** @type {((inputs?: Previewdevicemobile2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewdevicemobile2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewdevicemobile2(inputs)
	return __fr.previewdevicemobile2(inputs)
});
export { previewdevicemobile2 as "previewDeviceMobile" }
/**
* | output |
* | --- |
* | "Preview display size" |
*
* @param {Previewdeviceswitch2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewdeviceswitch2 = /** @type {((inputs?: Previewdeviceswitch2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewdeviceswitch2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewdeviceswitch2(inputs)
	return __fr.previewdeviceswitch2(inputs)
});
export { previewdeviceswitch2 as "previewDeviceSwitch" }
/**
* | output |
* | --- |
* | "Tablet" |
*
* @param {Previewdevicetablet2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewdevicetablet2 = /** @type {((inputs?: Previewdevicetablet2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewdevicetablet2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewdevicetablet2(inputs)
	return __fr.previewdevicetablet2(inputs)
});
export { previewdevicetablet2 as "previewDeviceTablet" }
/**
* | output |
* | --- |
* | "Preview for this conversation is not available right now." |
*
* @param {Previewoff1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewoff1 = /** @type {((inputs?: Previewoff1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewoff1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewoff1(inputs)
	return __fr.previewoff1(inputs)
});
export { previewoff1 as "previewOff" }
/**
* | output |
* | --- |
* | "Go" |
*
* @param {Previewpathapply2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathapply2 = /** @type {((inputs?: Previewpathapply2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathapply2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathapply2(inputs)
	return __fr.previewpathapply2(inputs)
});
export { previewpathapply2 as "previewPathApply" }
/**
* | output |
* | --- |
* | "Back" |
*
* @param {Previewpathback2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathback2 = /** @type {((inputs?: Previewpathback2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathback2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathback2(inputs)
	return __fr.previewpathback2(inputs)
});
export { previewpathback2 as "previewPathBack" }
/**
* | output |
* | --- |
* | "Forward" |
*
* @param {Previewpathforward2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathforward2 = /** @type {((inputs?: Previewpathforward2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathforward2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathforward2(inputs)
	return __fr.previewpathforward2(inputs)
});
export { previewpathforward2 as "previewPathForward" }
/**
* | output |
* | --- |
* | "Error: invalid path." |
*
* @param {Previewpathinvalid2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathinvalid2 = /** @type {((inputs?: Previewpathinvalid2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathinvalid2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathinvalid2(inputs)
	return __fr.previewpathinvalid2(inputs)
});
export { previewpathinvalid2 as "previewPathInvalid" }
/**
* | output |
* | --- |
* | "Preview path" |
*
* @param {Previewpathlabel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathlabel2 = /** @type {((inputs?: Previewpathlabel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathlabel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathlabel2(inputs)
	return __fr.previewpathlabel2(inputs)
});
export { previewpathlabel2 as "previewPathLabel" }
/**
* | output |
* | --- |
* | "Error: that address is not on the preview origin." |
*
* @param {Previewpathofforigin3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathofforigin3 = /** @type {((inputs?: Previewpathofforigin3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathofforigin3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathofforigin3(inputs)
	return __fr.previewpathofforigin3(inputs)
});
export { previewpathofforigin3 as "previewPathOffOrigin" }
/**
* | output |
* | --- |
* | "Catalogue" |
*
* @param {Previewpathpresetcatalogue3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathpresetcatalogue3 = /** @type {((inputs?: Previewpathpresetcatalogue3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathpresetcatalogue3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathpresetcatalogue3(inputs)
	return __fr.previewpathpresetcatalogue3(inputs)
});
export { previewpathpresetcatalogue3 as "previewPathPresetCatalogue" }
/**
* | output |
* | --- |
* | "Slideshow" |
*
* @param {Previewpathpresetdiaporama3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathpresetdiaporama3 = /** @type {((inputs?: Previewpathpresetdiaporama3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathpresetdiaporama3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathpresetdiaporama3(inputs)
	return __fr.previewpathpresetdiaporama3(inputs)
});
export { previewpathpresetdiaporama3 as "previewPathPresetDiaporama" }
/**
* | output |
* | --- |
* | "Home" |
*
* @param {Previewpathpresethome3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathpresethome3 = /** @type {((inputs?: Previewpathpresethome3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathpresethome3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathpresethome3(inputs)
	return __fr.previewpathpresethome3(inputs)
});
export { previewpathpresethome3 as "previewPathPresetHome" }
/**
* | output |
* | --- |
* | "Quick paths" |
*
* @param {Previewpathpresets2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewpathpresets2 = /** @type {((inputs?: Previewpathpresets2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewpathpresets2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewpathpresets2(inputs)
	return __fr.previewpathpresets2(inputs)
});
export { previewpathpresets2 as "previewPathPresets" }
/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Previewregion1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewregion1 = /** @type {((inputs?: Previewregion1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewregion1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewregion1(inputs)
	return __fr.previewregion1(inputs)
});
export { previewregion1 as "previewRegion" }
/**
* | output |
* | --- |
* | "Preparing preview…" |
*
* @param {Previewrestoring1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const previewrestoring1 = /** @type {((inputs?: Previewrestoring1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previewrestoring1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.previewrestoring1(inputs)
	return __fr.previewrestoring1(inputs)
});
export { previewrestoring1 as "previewRestoring" }
/**
* | output |
* | --- |
* | "Close the log" |
*
* @param {Promptactivityclose2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const promptactivityclose2 = /** @type {((inputs?: Promptactivityclose2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promptactivityclose2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.promptactivityclose2(inputs)
	return __fr.promptactivityclose2(inputs)
});
export { promptactivityclose2 as "promptActivityClose" }
/**
* | output |
* | --- |
* | "No recent prompts." |
*
* @param {Promptactivityempty2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const promptactivityempty2 = /** @type {((inputs?: Promptactivityempty2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promptactivityempty2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.promptactivityempty2(inputs)
	return __fr.promptactivityempty2(inputs)
});
export { promptactivityempty2 as "promptActivityEmpty" }
/**
* | output |
* | --- |
* | "Latest agent turns started on this studio." |
*
* @param {Promptactivitylead2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const promptactivitylead2 = /** @type {((inputs?: Promptactivitylead2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promptactivitylead2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.promptactivitylead2(inputs)
	return __fr.promptactivitylead2(inputs)
});
export { promptactivitylead2 as "promptActivityLead" }
/**
* | output |
* | --- |
* | "Could not load the activity log." |
*
* @param {Promptactivityloadfailed3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const promptactivityloadfailed3 = /** @type {((inputs?: Promptactivityloadfailed3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promptactivityloadfailed3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.promptactivityloadfailed3(inputs)
	return __fr.promptactivityloadfailed3(inputs)
});
export { promptactivityloadfailed3 as "promptActivityLoadFailed" }
/**
* | output |
* | --- |
* | "Recent prompts" |
*
* @param {Promptactivitytitle2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const promptactivitytitle2 = /** @type {((inputs?: Promptactivitytitle2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promptactivitytitle2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.promptactivitytitle2(inputs)
	return __fr.promptactivitytitle2(inputs)
});
export { promptactivitytitle2 as "promptActivityTitle" }
/**
* | output |
* | --- |
* | "(untitled)" |
*
* @param {Promptactivityuntitled2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const promptactivityuntitled2 = /** @type {((inputs?: Promptactivityuntitled2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promptactivityuntitled2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.promptactivityuntitled2(inputs)
	return __fr.promptactivityuntitled2(inputs)
});
export { promptactivityuntitled2 as "promptActivityUntitled" }
/**
* | output |
* | --- |
* | "Send" |
*
* @param {Quickstartaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const quickstartaction2 = /** @type {((inputs?: Quickstartaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quickstartaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.quickstartaction2(inputs)
	return __fr.quickstartaction2(inputs)
});
export { quickstartaction2 as "quickStartAction" }
/**
* | output |
* | --- |
* | "Your request" |
*
* @param {Quickstartlabel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const quickstartlabel2 = /** @type {((inputs?: Quickstartlabel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quickstartlabel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.quickstartlabel2(inputs)
	return __fr.quickstartlabel2(inputs)
});
export { quickstartlabel2 as "quickStartLabel" }
/**
* | output |
* | --- |
* | "The starter application is not available yet. Try again shortly or create a new app." |
*
* @param {Quickstartnostartertarget4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const quickstartnostartertarget4 = /** @type {((inputs?: Quickstartnostartertarget4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quickstartnostartertarget4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.quickstartnostartertarget4(inputs)
	return __fr.quickstartnostartertarget4(inputs)
});
export { quickstartnostartertarget4 as "quickStartNoStarterTarget" }
/**
* | output |
* | --- |
* | "Ask anything, or describe what you want to build…" |
*
* @param {Quickstartplaceholder2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const quickstartplaceholder2 = /** @type {((inputs?: Quickstartplaceholder2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quickstartplaceholder2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.quickstartplaceholder2(inputs)
	return __fr.quickstartplaceholder2(inputs)
});
export { quickstartplaceholder2 as "quickStartPlaceholder" }
/**
* | output |
* | --- |
* | "Creating the conversation…" |
*
* @param {Quickstartworking2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const quickstartworking2 = /** @type {((inputs?: Quickstartworking2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quickstartworking2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.quickstartworking2(inputs)
	return __fr.quickstartworking2(inputs)
});
export { quickstartworking2 as "quickStartWorking" }
/**
* | output |
* | --- |
* | "Update deployment" |
*
* @param {Redeploysessionaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const redeploysessionaction2 = /** @type {((inputs?: Redeploysessionaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Redeploysessionaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.redeploysessionaction2(inputs)
	return __fr.redeploysessionaction2(inputs)
});
export { redeploysessionaction2 as "redeploySessionAction" }
/**
* | output |
* | --- |
* | "Remove {fileName}" |
*
* @param {Removeattachment1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const removeattachment1 = /** @type {((inputs: Removeattachment1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Removeattachment1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.removeattachment1(inputs)
	return __fr.removeattachment1(inputs)
});
export { removeattachment1 as "removeAttachment" }
/**
* | output |
* | --- |
* | "Remove {label}" |
*
* @param {Removeselection1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const removeselection1 = /** @type {((inputs: Removeselection1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Removeselection1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.removeselection1(inputs)
	return __fr.removeselection1(inputs)
});
export { removeselection1 as "removeSelection" }
/**
* | output |
* | --- |
* | "Rename conversation" |
*
* @param {Renameconversation1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const renameconversation1 = /** @type {((inputs?: Renameconversation1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Renameconversation1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.renameconversation1(inputs)
	return __fr.renameconversation1(inputs)
});
export { renameconversation1 as "renameConversation" }
/**
* | output |
* | --- |
* | "Describe what you want before continuing." |
*
* @param {Requestrequired1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const requestrequired1 = /** @type {((inputs?: Requestrequired1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestrequired1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.requestrequired1(inputs)
	return __fr.requestrequired1(inputs)
});
export { requestrequired1 as "requestRequired" }
/**
* | output |
* | --- |
* | "Resize conversation" |
*
* @param {Resizechat1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const resizechat1 = /** @type {((inputs?: Resizechat1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resizechat1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.resizechat1(inputs)
	return __fr.resizechat1(inputs)
});
export { resizechat1 as "resizeChat" }
/**
* | output |
* | --- |
* | "Collapse conversation" |
*
* @param {Restorechat1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const restorechat1 = /** @type {((inputs?: Restorechat1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Restorechat1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.restorechat1(inputs)
	return __fr.restorechat1(inputs)
});
export { restorechat1 as "restoreChat" }
/**
* | output |
* | --- |
* | "Save title" |
*
* @param {Saveconversationtitle2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const saveconversationtitle2 = /** @type {((inputs?: Saveconversationtitle2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saveconversationtitle2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.saveconversationtitle2(inputs)
	return __fr.saveconversationtitle2(inputs)
});
export { saveconversationtitle2 as "saveConversationTitle" }
/**
* | output |
* | --- |
* | "Secure space" |
*
* @param {Securespace1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const securespace1 = /** @type {((inputs?: Securespace1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Securespace1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.securespace1(inputs)
	return __fr.securespace1(inputs)
});
export { securespace1 as "secureSpace" }
/**
* | output |
* | --- |
* | "Select an element" |
*
* @param {Selectcomponent1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const selectcomponent1 = /** @type {((inputs?: Selectcomponent1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selectcomponent1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.selectcomponent1(inputs)
	return __fr.selectcomponent1(inputs)
});
export { selectcomponent1 as "selectComponent" }
/**
* | output |
* | --- |
* | "Send" |
*
* @param {Sendmessage1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sendmessage1 = /** @type {((inputs?: Sendmessage1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sendmessage1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sendmessage1(inputs)
	return __fr.sendmessage1(inputs)
});
export { sendmessage1 as "sendMessage" }
/**
* | output |
* | --- |
* | "The service is temporarily unavailable." |
*
* @param {Servicetemporarilyunavailable2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const servicetemporarilyunavailable2 = /** @type {((inputs?: Servicetemporarilyunavailable2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servicetemporarilyunavailable2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.servicetemporarilyunavailable2(inputs)
	return __fr.servicetemporarilyunavailable2(inputs)
});
export { servicetemporarilyunavailable2 as "serviceTemporarilyUnavailable" }
/**
* | output |
* | --- |
* | "You do not have access to this conversation." |
*
* @param {Sessionaccessdenied2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionaccessdenied2 = /** @type {((inputs?: Sessionaccessdenied2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionaccessdenied2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionaccessdenied2(inputs)
	return __fr.sessionaccessdenied2(inputs)
});
export { sessionaccessdenied2 as "sessionAccessDenied" }
/**
* | output |
* | --- |
* | "Ask the creator to share it or make it open." |
*
* @param {Sessionaccessdeniedlead3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionaccessdeniedlead3 = /** @type {((inputs?: Sessionaccessdeniedlead3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionaccessdeniedlead3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionaccessdeniedlead3(inputs)
	return __fr.sessionaccessdeniedlead3(inputs)
});
export { sessionaccessdeniedlead3 as "sessionAccessDeniedLead" }
/**
* | output |
* | --- |
* | "Loading conversation…" |
*
* @param {Sessionloading1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionloading1 = /** @type {((inputs?: Sessionloading1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionloading1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionloading1(inputs)
	return __fr.sessionloading1(inputs)
});
export { sessionloading1 as "sessionLoading" }
/**
* | output |
* | --- |
* | "Make open" |
*
* @param {Sessionmakeopen2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionmakeopen2 = /** @type {((inputs?: Sessionmakeopen2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionmakeopen2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionmakeopen2(inputs)
	return __fr.sessionmakeopen2(inputs)
});
export { sessionmakeopen2 as "sessionMakeOpen" }
/**
* | output |
* | --- |
* | "Make private" |
*
* @param {Sessionmakeprivate2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionmakeprivate2 = /** @type {((inputs?: Sessionmakeprivate2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionmakeprivate2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionmakeprivate2(inputs)
	return __fr.sessionmakeprivate2(inputs)
});
export { sessionmakeprivate2 as "sessionMakePrivate" }
/**
* | output |
* | --- |
* | "Conversation not found." |
*
* @param {Sessionmissing1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionmissing1 = /** @type {((inputs?: Sessionmissing1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionmissing1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionmissing1(inputs)
	return __fr.sessionmissing1(inputs)
});
export { sessionmissing1 as "sessionMissing" }
/**

* @param {Sessionpublishmenu2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionpublishmenu2 = /** @type {((inputs?: Sessionpublishmenu2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionpublishmenu2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionpublishmenu2(inputs)
	return __fr.sessionpublishmenu2(inputs)
});
export { sessionpublishmenu2 as "sessionPublishMenu" }
/**
* | output |
* | --- |
* | "Invite" |
*
* @param {Sessionshareadd2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionshareadd2 = /** @type {((inputs?: Sessionshareadd2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionshareadd2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionshareadd2(inputs)
	return __fr.sessionshareadd2(inputs)
});
export { sessionshareadd2 as "sessionShareAdd" }
/**
* | output |
* | --- |
* | "email to invite" |
*
* @param {Sessionshareemailplaceholder3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionshareemailplaceholder3 = /** @type {((inputs?: Sessionshareemailplaceholder3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionshareemailplaceholder3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionshareemailplaceholder3(inputs)
	return __fr.sessionshareemailplaceholder3(inputs)
});
export { sessionshareemailplaceholder3 as "sessionShareEmailPlaceholder" }
/**
* | output |
* | --- |
* | "This conversation was shared with you." |
*
* @param {Sessionsharedwithyou3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionsharedwithyou3 = /** @type {((inputs?: Sessionsharedwithyou3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionsharedwithyou3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionsharedwithyou3(inputs)
	return __fr.sessionsharedwithyou3(inputs)
});
export { sessionsharedwithyou3 as "sessionSharedWithYou" }
/**
* | output |
* | --- |
* | "Conversation sharing" |
*
* @param {Sessionsharing1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionsharing1 = /** @type {((inputs?: Sessionsharing1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionsharing1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionsharing1(inputs)
	return __fr.sessionsharing1(inputs)
});
export { sessionsharing1 as "sessionSharing" }
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Sessionunshare1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionunshare1 = /** @type {((inputs?: Sessionunshare1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionunshare1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionunshare1(inputs)
	return __fr.sessionunshare1(inputs)
});
export { sessionunshare1 as "sessionUnshare" }
/**
* | output |
* | --- |
* | "Remove {email}" |
*
* @param {Sessionunshareemail2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionunshareemail2 = /** @type {((inputs: Sessionunshareemail2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionunshareemail2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionunshareemail2(inputs)
	return __fr.sessionunshareemail2(inputs)
});
export { sessionunshareemail2 as "sessionUnshareEmail" }
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Sessionvisibilityopen2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionvisibilityopen2 = /** @type {((inputs?: Sessionvisibilityopen2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionvisibilityopen2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionvisibilityopen2(inputs)
	return __fr.sessionvisibilityopen2(inputs)
});
export { sessionvisibilityopen2 as "sessionVisibilityOpen" }
/**
* | output |
* | --- |
* | "Private" |
*
* @param {Sessionvisibilityprivate2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sessionvisibilityprivate2 = /** @type {((inputs?: Sessionvisibilityprivate2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionvisibilityprivate2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sessionvisibilityprivate2(inputs)
	return __fr.sessionvisibilityprivate2(inputs)
});
export { sessionvisibilityprivate2 as "sessionVisibilityPrivate" }
/**
* | output |
* | --- |
* | "Settings" |
*
* @param {SettingsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings = /** @type {((inputs?: SettingsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SettingsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings(inputs)
	return __fr.settings(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Settingsclose1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingsclose1 = /** @type {((inputs?: Settingsclose1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsclose1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingsclose1(inputs)
	return __fr.settingsclose1(inputs)
});
export { settingsclose1 as "settingsClose" }
/**
* | output |
* | --- |
* | "Application creation" |
*
* @param {Settingscreateappheading3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingscreateappheading3 = /** @type {((inputs?: Settingscreateappheading3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingscreateappheading3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingscreateappheading3(inputs)
	return __fr.settingscreateappheading3(inputs)
});
export { settingscreateappheading3 as "settingsCreateAppHeading" }
/**
* | output |
* | --- |
* | "When enabled, the menu to create an independent application appears on the applications screen (if your account allows it)." |
*
* @param {Settingscreateapplead3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingscreateapplead3 = /** @type {((inputs?: Settingscreateapplead3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingscreateapplead3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingscreateapplead3(inputs)
	return __fr.settingscreateapplead3(inputs)
});
export { settingscreateapplead3 as "settingsCreateAppLead" }
/**
* | output |
* | --- |
* | "Experimental menu on the applications screen" |
*
* @param {Settingscreateappsubtitle3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingscreateappsubtitle3 = /** @type {((inputs?: Settingscreateappsubtitle3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingscreateappsubtitle3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingscreateappsubtitle3(inputs)
	return __fr.settingscreateappsubtitle3(inputs)
});
export { settingscreateappsubtitle3 as "settingsCreateAppSubtitle" }
/**
* | output |
* | --- |
* | "Show “New app”" |
*
* @param {Settingscreateapptoggle3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingscreateapptoggle3 = /** @type {((inputs?: Settingscreateapptoggle3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingscreateapptoggle3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingscreateapptoggle3(inputs)
	return __fr.settingscreateapptoggle3(inputs)
});
export { settingscreateapptoggle3 as "settingsCreateAppToggle" }
/**
* | output |
* | --- |
* | "Application deletion" |
*
* @param {Settingsdeleteappheading3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingsdeleteappheading3 = /** @type {((inputs?: Settingsdeleteappheading3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsdeleteappheading3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingsdeleteappheading3(inputs)
	return __fr.settingsdeleteappheading3(inputs)
});
export { settingsdeleteappheading3 as "settingsDeleteAppHeading" }
/**
* | output |
* | --- |
* | "When enabled, a Delete action appears on Independent apps tiles (if your account allows creating apps). Deployed apps must be stopped first. The default star..." |
*
* @param {Settingsdeleteapplead3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingsdeleteapplead3 = /** @type {((inputs?: Settingsdeleteapplead3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsdeleteapplead3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingsdeleteapplead3(inputs)
	return __fr.settingsdeleteapplead3(inputs)
});
export { settingsdeleteapplead3 as "settingsDeleteAppLead" }
/**
* | output |
* | --- |
* | "Destructive actions on independent apps" |
*
* @param {Settingsdeleteappsubtitle3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingsdeleteappsubtitle3 = /** @type {((inputs?: Settingsdeleteappsubtitle3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsdeleteappsubtitle3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingsdeleteappsubtitle3(inputs)
	return __fr.settingsdeleteappsubtitle3(inputs)
});
export { settingsdeleteappsubtitle3 as "settingsDeleteAppSubtitle" }
/**
* | output |
* | --- |
* | "Show “Delete” on independent apps" |
*
* @param {Settingsdeleteapptoggle3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingsdeleteapptoggle3 = /** @type {((inputs?: Settingsdeleteapptoggle3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsdeleteapptoggle3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingsdeleteapptoggle3(inputs)
	return __fr.settingsdeleteapptoggle3(inputs)
});
export { settingsdeleteapptoggle3 as "settingsDeleteAppToggle" }
/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Settingseyebrow1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingseyebrow1 = /** @type {((inputs?: Settingseyebrow1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingseyebrow1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingseyebrow1(inputs)
	return __fr.settingseyebrow1(inputs)
});
export { settingseyebrow1 as "settingsEyebrow" }
/**
* | output |
* | --- |
* | "Preview navigation" |
*
* @param {Settingspreviewpathbarheading4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingspreviewpathbarheading4 = /** @type {((inputs?: Settingspreviewpathbarheading4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingspreviewpathbarheading4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingspreviewpathbarheading4(inputs)
	return __fr.settingspreviewpathbarheading4(inputs)
});
export { settingspreviewpathbarheading4 as "settingsPreviewPathBarHeading" }
/**
* | output |
* | --- |
* | "Shows the address bar and shortcuts (catalogue, slideshow…) at the top of the preview." |
*
* @param {Settingspreviewpathbarlead4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingspreviewpathbarlead4 = /** @type {((inputs?: Settingspreviewpathbarlead4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingspreviewpathbarlead4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingspreviewpathbarlead4(inputs)
	return __fr.settingspreviewpathbarlead4(inputs)
});
export { settingspreviewpathbarlead4 as "settingsPreviewPathBarLead" }
/**
* | output |
* | --- |
* | "Address bar and shortcuts (catalogue, slideshow…)" |
*
* @param {Settingspreviewpathbarsubtitle4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingspreviewpathbarsubtitle4 = /** @type {((inputs?: Settingspreviewpathbarsubtitle4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingspreviewpathbarsubtitle4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingspreviewpathbarsubtitle4(inputs)
	return __fr.settingspreviewpathbarsubtitle4(inputs)
});
export { settingspreviewpathbarsubtitle4 as "settingsPreviewPathBarSubtitle" }
/**
* | output |
* | --- |
* | "Show the preview navigation bar" |
*
* @param {Settingspreviewpathbartoggle4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingspreviewpathbartoggle4 = /** @type {((inputs?: Settingspreviewpathbartoggle4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingspreviewpathbartoggle4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingspreviewpathbartoggle4(inputs)
	return __fr.settingspreviewpathbartoggle4(inputs)
});
export { settingspreviewpathbartoggle4 as "settingsPreviewPathBarToggle" }
/**
* | output |
* | --- |
* | "Prompt activity log" |
*
* @param {Settingspromptactivityheading3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingspromptactivityheading3 = /** @type {((inputs?: Settingspromptactivityheading3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingspromptactivityheading3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingspromptactivityheading3(inputs)
	return __fr.settingspromptactivityheading3(inputs)
});
export { settingspromptactivityheading3 as "settingsPromptActivityHeading" }
/**
* | output |
* | --- |
* | "Opens a window listing recent prompts on this studio (email, time, conversation). Useful before a restart or update." |
*
* @param {Settingspromptactivitylead3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingspromptactivitylead3 = /** @type {((inputs?: Settingspromptactivitylead3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingspromptactivitylead3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingspromptactivitylead3(inputs)
	return __fr.settingspromptactivitylead3(inputs)
});
export { settingspromptactivitylead3 as "settingsPromptActivityLead" }
/**
* | output |
* | --- |
* | "Who launched a prompt, and when" |
*
* @param {Settingspromptactivitysubtitle3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingspromptactivitysubtitle3 = /** @type {((inputs?: Settingspromptactivitysubtitle3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingspromptactivitysubtitle3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingspromptactivitysubtitle3(inputs)
	return __fr.settingspromptactivitysubtitle3(inputs)
});
export { settingspromptactivitysubtitle3 as "settingsPromptActivitySubtitle" }
/**
* | output |
* | --- |
* | "Show the prompt activity log" |
*
* @param {Settingspromptactivitytoggle3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingspromptactivitytoggle3 = /** @type {((inputs?: Settingspromptactivitytoggle3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingspromptactivitytoggle3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingspromptactivitytoggle3(inputs)
	return __fr.settingspromptactivitytoggle3(inputs)
});
export { settingspromptactivitytoggle3 as "settingsPromptActivityToggle" }
/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Settingstitle1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const settingstitle1 = /** @type {((inputs?: Settingstitle1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingstitle1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settingstitle1(inputs)
	return __fr.settingstitle1(inputs)
});
export { settingstitle1 as "settingsTitle" }
/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Sourceconnectaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sourceconnectaction2 = /** @type {((inputs?: Sourceconnectaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourceconnectaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sourceconnectaction2(inputs)
	return __fr.sourceconnectaction2(inputs)
});
export { sourceconnectaction2 as "sourceConnectAction" }
/**
* | output |
* | --- |
* | "Connect open" |
*
* @param {Sourceconnectconnecting2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sourceconnectconnecting2 = /** @type {((inputs?: Sourceconnectconnecting2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourceconnectconnecting2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sourceconnectconnecting2(inputs)
	return __fr.sourceconnectconnecting2(inputs)
});
export { sourceconnectconnecting2 as "sourceConnectConnecting" }
/**
* | output |
* | --- |
* | "Open browser" |
*
* @param {Sourceconnectopenviewer3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sourceconnectopenviewer3 = /** @type {((inputs?: Sourceconnectopenviewer3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourceconnectopenviewer3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sourceconnectopenviewer3(inputs)
	return __fr.sourceconnectopenviewer3(inputs)
});
export { sourceconnectopenviewer3 as "sourceConnectOpenViewer" }
/**
* | output |
* | --- |
* | "Skip" |
*
* @param {Sourceconnectskip2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sourceconnectskip2 = /** @type {((inputs?: Sourceconnectskip2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourceconnectskip2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sourceconnectskip2(inputs)
	return __fr.sourceconnectskip2(inputs)
});
export { sourceconnectskip2 as "sourceConnectSkip" }
/**
* | output |
* | --- |
* | "Browser sources" |
*
* @param {Sourceconnecttitle2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const sourceconnecttitle2 = /** @type {((inputs?: Sourceconnecttitle2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourceconnecttitle2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.sourceconnecttitle2(inputs)
	return __fr.sourceconnecttitle2(inputs)
});
export { sourceconnecttitle2 as "sourceConnectTitle" }
/**
* | output |
* | --- |
* | "Show preview" |
*
* @param {Startpreview1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const startpreview1 = /** @type {((inputs?: Startpreview1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Startpreview1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.startpreview1(inputs)
	return __fr.startpreview1(inputs)
});
export { startpreview1 as "startPreview" }
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Startsectionlabel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const startsectionlabel2 = /** @type {((inputs?: Startsectionlabel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Startsectionlabel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.startsectionlabel2(inputs)
	return __fr.startsectionlabel2(inputs)
});
export { startsectionlabel2 as "startSectionLabel" }
/**
* | output |
* | --- |
* | "Describe what you want. We open a session on the starter application." |
*
* @param {Startsectionlead2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const startsectionlead2 = /** @type {((inputs?: Startsectionlead2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Startsectionlead2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.startsectionlead2(inputs)
	return __fr.startsectionlead2(inputs)
});
export { startsectionlead2 as "startSectionLead" }
/**
* | output |
* | --- |
* | "How can I help you?" |
*
* @param {Startsectiontitle2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const startsectiontitle2 = /** @type {((inputs?: Startsectiontitle2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Startsectiontitle2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.startsectiontitle2(inputs)
	return __fr.startsectiontitle2(inputs)
});
export { startsectiontitle2 as "startSectionTitle" }
/**
* | output |
* | --- |
* | "Creating the conversation…" |
*
* @param {Startingrequest1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const startingrequest1 = /** @type {((inputs?: Startingrequest1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Startingrequest1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.startingrequest1(inputs)
	return __fr.startingrequest1(inputs)
});
export { startingrequest1 as "startingRequest" }
/**
* | output |
* | --- |
* | "Stop dictation" |
*
* @param {Stopdictation1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const stopdictation1 = /** @type {((inputs?: Stopdictation1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stopdictation1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.stopdictation1(inputs)
	return __fr.stopdictation1(inputs)
});
export { stopdictation1 as "stopDictation" }
/**
* | output |
* | --- |
* | "Stop selecting" |
*
* @param {Stopselectingcomponent2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const stopselectingcomponent2 = /** @type {((inputs?: Stopselectingcomponent2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stopselectingcomponent2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.stopselectingcomponent2(inputs)
	return __fr.stopselectingcomponent2(inputs)
});
export { stopselectingcomponent2 as "stopSelectingComponent" }
/**
* | output |
* | --- |
* | "Stop turn" |
*
* @param {Stopturn1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const stopturn1 = /** @type {((inputs?: Stopturn1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stopturn1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.stopturn1(inputs)
	return __fr.stopturn1(inputs)
});
export { stopturn1 as "stopTurn" }
/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Studioname1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const studioname1 = /** @type {((inputs?: Studioname1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studioname1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.studioname1(inputs)
	return __fr.studioname1(inputs)
});
export { studioname1 as "studioName" }
/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Studiowelcomeeyebrow2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const studiowelcomeeyebrow2 = /** @type {((inputs?: Studiowelcomeeyebrow2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studiowelcomeeyebrow2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.studiowelcomeeyebrow2(inputs)
	return __fr.studiowelcomeeyebrow2(inputs)
});
export { studiowelcomeeyebrow2 as "studioWelcomeEyebrow" }
/**
* | output |
* | --- |
* | "What should we tackle, {name}?" |
*
* @param {Studiowelcometitleattack3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const studiowelcometitleattack3 = /** @type {((inputs: Studiowelcometitleattack3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studiowelcometitleattack3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.studiowelcometitleattack3(inputs)
	return __fr.studiowelcometitleattack3(inputs)
});
export { studiowelcometitleattack3 as "studioWelcomeTitleAttack" }
/**
* | output |
* | --- |
* | "Which app are we polishing, {name}?" |
*
* @param {Studiowelcometitleembellish3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const studiowelcometitleembellish3 = /** @type {((inputs: Studiowelcometitleembellish3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studiowelcometitleembellish3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.studiowelcometitleembellish3(inputs)
	return __fr.studiowelcometitleembellish3(inputs)
});
export { studiowelcometitleembellish3 as "studioWelcomeTitleEmbellish" }
/**
* | output |
* | --- |
* | "Hi {name}, what are we working on today?" |
*
* @param {Studiowelcometitlehello3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const studiowelcometitlehello3 = /** @type {((inputs: Studiowelcometitlehello3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studiowelcometitlehello3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.studiowelcometitlehello3(inputs)
	return __fr.studiowelcometitlehello3(inputs)
});
export { studiowelcometitlehello3 as "studioWelcomeTitleHello" }
/**
* | output |
* | --- |
* | "{name}, an idea to bring to life?" |
*
* @param {Studiowelcometitleidea3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const studiowelcometitleidea3 = /** @type {((inputs: Studiowelcometitleidea3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studiowelcometitleidea3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.studiowelcometitleidea3(inputs)
	return __fr.studiowelcometitleidea3(inputs)
});
export { studiowelcometitleidea3 as "studioWelcomeTitleIdea" }
/**
* | output |
* | --- |
* | "What would you like to improve, {name}?" |
*
* @param {Studiowelcometitleimprove3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const studiowelcometitleimprove3 = /** @type {((inputs: Studiowelcometitleimprove3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Studiowelcometitleimprove3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.studiowelcometitleimprove3(inputs)
	return __fr.studiowelcometitleimprove3(inputs)
});
export { studiowelcometitleimprove3 as "studioWelcomeTitleImprove" }
/**

* @param {Syncsessionbase2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const syncsessionbase2 = /** @type {((inputs?: Syncsessionbase2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Syncsessionbase2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.syncsessionbase2(inputs)
	return __fr.syncsessionbase2(inputs)
});
export { syncsessionbase2 as "syncSessionBase" }
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Targetopenaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targetopenaction2 = /** @type {((inputs?: Targetopenaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetopenaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targetopenaction2(inputs)
	return __fr.targetopenaction2(inputs)
});
export { targetopenaction2 as "targetOpenAction" }
/**
* | output |
* | --- |
* | "No applications registered yet." |
*
* @param {Targetpickerempty2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targetpickerempty2 = /** @type {((inputs?: Targetpickerempty2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetpickerempty2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targetpickerempty2(inputs)
	return __fr.targetpickerempty2(inputs)
});
export { targetpickerempty2 as "targetPickerEmpty" }
/**
* | output |
* | --- |
* | "Describe an idea to start, or pick an application from the menu." |
*
* @param {Targetpickerlead2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targetpickerlead2 = /** @type {((inputs?: Targetpickerlead2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetpickerlead2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targetpickerlead2(inputs)
	return __fr.targetpickerlead2(inputs)
});
export { targetpickerlead2 as "targetPickerLead" }
/**
* | output |
* | --- |
* | "Preview of {label}" |
*
* @param {Targetpreviewlabel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targetpreviewlabel2 = /** @type {((inputs: Targetpreviewlabel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetpreviewlabel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targetpreviewlabel2(inputs)
	return __fr.targetpreviewlabel2(inputs)
});
export { targetpreviewlabel2 as "targetPreviewLabel" }
/**
* | output |
* | --- |
* | "Preview unavailable" |
*
* @param {Targetpreviewunavailable2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targetpreviewunavailable2 = /** @type {((inputs?: Targetpreviewunavailable2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetpreviewunavailable2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targetpreviewunavailable2(inputs)
	return __fr.targetpreviewunavailable2(inputs)
});
export { targetpreviewunavailable2 as "targetPreviewUnavailable" }
/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Targetresumeaction2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targetresumeaction2 = /** @type {((inputs?: Targetresumeaction2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetresumeaction2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targetresumeaction2(inputs)
	return __fr.targetresumeaction2(inputs)
});
export { targetresumeaction2 as "targetResumeAction" }
/**
* | output |
* | --- |
* | "Application to edit" |
*
* @param {Targetselectlabel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targetselectlabel2 = /** @type {((inputs?: Targetselectlabel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetselectlabel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targetselectlabel2(inputs)
	return __fr.targetselectlabel2(inputs)
});
export { targetselectlabel2 as "targetSelectLabel" }
/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Targettilemenulabel3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targettilemenulabel3 = /** @type {((inputs?: Targettilemenulabel3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targettilemenulabel3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targettilemenulabel3(inputs)
	return __fr.targettilemenulabel3(inputs)
});
export { targettilemenulabel3 as "targetTileMenuLabel" }
/**
* | output |
* | --- |
* | "In progress" |
*
* @param {Targetwipbadge2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const targetwipbadge2 = /** @type {((inputs?: Targetwipbadge2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetwipbadge2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.targetwipbadge2(inputs)
	return __fr.targetwipbadge2(inputs)
});
export { targetwipbadge2 as "targetWipBadge" }
/**
* | output |
* | --- |
* | "Discard draft" |
*
* @param {Teachbrowserdiscard2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const teachbrowserdiscard2 = /** @type {((inputs?: Teachbrowserdiscard2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teachbrowserdiscard2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.teachbrowserdiscard2(inputs)
	return __fr.teachbrowserdiscard2(inputs)
});
export { teachbrowserdiscard2 as "teachBrowserDiscard" }
/**
* | output |
* | --- |
* | "Open browser viewer" |
*
* @param {Teachbrowseropenviewer3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const teachbrowseropenviewer3 = /** @type {((inputs?: Teachbrowseropenviewer3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teachbrowseropenviewer3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.teachbrowseropenviewer3(inputs)
	return __fr.teachbrowseropenviewer3(inputs)
});
export { teachbrowseropenviewer3 as "teachBrowserOpenViewer" }
/**
* | output |
* | --- |
* | "Promote taught skill" |
*
* @param {Teachbrowserpromote2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const teachbrowserpromote2 = /** @type {((inputs?: Teachbrowserpromote2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teachbrowserpromote2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.teachbrowserpromote2(inputs)
	return __fr.teachbrowserpromote2(inputs)
});
export { teachbrowserpromote2 as "teachBrowserPromote" }
/**
* | output |
* | --- |
* | "Draft skill ready" |
*
* @param {Teachbrowserready2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const teachbrowserready2 = /** @type {((inputs?: Teachbrowserready2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teachbrowserready2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.teachbrowserready2(inputs)
	return __fr.teachbrowserready2(inputs)
});
export { teachbrowserready2 as "teachBrowserReady" }
/**
* | output |
* | --- |
* | "Recording — demonstrate the flow in the viewer" |
*
* @param {Teachbrowserrecording2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const teachbrowserrecording2 = /** @type {((inputs?: Teachbrowserrecording2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teachbrowserrecording2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.teachbrowserrecording2(inputs)
	return __fr.teachbrowserrecording2(inputs)
});
export { teachbrowserrecording2 as "teachBrowserRecording" }
/**
* | output |
* | --- |
* | "Show the path" |
*
* @param {Teachbrowsershowpath3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const teachbrowsershowpath3 = /** @type {((inputs?: Teachbrowsershowpath3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teachbrowsershowpath3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.teachbrowsershowpath3(inputs)
	return __fr.teachbrowsershowpath3(inputs)
});
export { teachbrowsershowpath3 as "teachBrowserShowPath" }
/**
* | output |
* | --- |
* | "Stop teaching" |
*
* @param {Teachbrowserstop2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const teachbrowserstop2 = /** @type {((inputs?: Teachbrowserstop2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teachbrowserstop2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.teachbrowserstop2(inputs)
	return __fr.teachbrowserstop2(inputs)
});
export { teachbrowserstop2 as "teachBrowserStop" }
/**
* | output |
* | --- |
* | "Teach summary" |
*
* @param {Teachbrowsersummary2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const teachbrowsersummary2 = /** @type {((inputs?: Teachbrowsersummary2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teachbrowsersummary2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.teachbrowsersummary2(inputs)
	return __fr.teachbrowsersummary2(inputs)
});
export { teachbrowsersummary2 as "teachBrowserSummary" }
/**
* | output |
* | --- |
* | "Technical details" |
*
* @param {Technicaldetails1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const technicaldetails1 = /** @type {((inputs?: Technicaldetails1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technicaldetails1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.technicaldetails1(inputs)
	return __fr.technicaldetails1(inputs)
});
export { technicaldetails1 as "technicalDetails" }
/**
* | output |
* | --- |
* | "Unknown creator" |
*
* @param {Unknowncreator1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const unknowncreator1 = /** @type {((inputs?: Unknowncreator1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unknowncreator1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.unknowncreator1(inputs)
	return __fr.unknowncreator1(inputs)
});
export { unknowncreator1 as "unknownCreator" }
/**
* | output |
* | --- |
* | "Remove from favorites" |
*
* @param {Unpinfavorite1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const unpinfavorite1 = /** @type {((inputs?: Unpinfavorite1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unpinfavorite1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.unpinfavorite1(inputs)
	return __fr.unpinfavorite1(inputs)
});
export { unpinfavorite1 as "unpinFavorite" }
/**
* | output |
* | --- |
* | "New conversation" |
*
* @param {Untitledconversation1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const untitledconversation1 = /** @type {((inputs?: Untitledconversation1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Untitledconversation1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.untitledconversation1(inputs)
	return __fr.untitledconversation1(inputs)
});
export { untitledconversation1 as "untitledConversation" }
/**
* | output |
* | --- |
* | "Update proposal" |
*
* @param {Updatemergerequest2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const updatemergerequest2 = /** @type {((inputs?: Updatemergerequest2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updatemergerequest2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.updatemergerequest2(inputs)
	return __fr.updatemergerequest2(inputs)
});
export { updatemergerequest2 as "updateMergeRequest" }
/**
* | output |
* | --- |
* | "No website targets registered yet." |
*
* @param {Websitesectionempty2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const websitesectionempty2 = /** @type {((inputs?: Websitesectionempty2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Websitesectionempty2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.websitesectionempty2(inputs)
	return __fr.websitesectionempty2(inputs)
});
export { websitesectionempty2 as "websiteSectionEmpty" }
/**
* | output |
* | --- |
* | "Website" |
*
* @param {Websitesectionlabel2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const websitesectionlabel2 = /** @type {((inputs?: Websitesectionlabel2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Websitesectionlabel2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.websitesectionlabel2(inputs)
	return __fr.websitesectionlabel2(inputs)
});
export { websitesectionlabel2 as "websiteSectionLabel" }
/**
* | output |
* | --- |
* | "You" |
*
* @param {Youname1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const youname1 = /** @type {((inputs?: Youname1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youname1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.youname1(inputs)
	return __fr.youname1(inputs)
});
export { youname1 as "youName" }